<template>
    <div class="content" v-show="next != 0">
        <div class="content-view" ref="scrollbar">
            <!-- v-show="!this.hidePage"  -->
            <div class="action" v-if="next == 1 && !this.hidePage">
                <div class="action-title">选择客户</div>
                <el-descriptions title="" :column="1" size="medium" labelClassName="custom-label">
                    <el-descriptions-item label="合同类型">
                        <!-- <el-select :disabled="changeOrderType == 1" v-model="Orders_Type" placeholder="请选择合同类型" @change="changeSPCOrderCreate">
                            <el-option v-for="item in orderTypeList" :key="item.ID" :label="item.Name" :value="item.ID"></el-option>
                        </el-select> -->
                        <el-radio-group :disabled="changeOrderType == 1" v-model="Orders_Type"
                            @input="changeSPCOrderCreate">
                            <el-radio v-for="item in orderTypeList" :key="item.ID" :label="item.ID" :value="item.ID">{{
                                item.Name }}</el-radio>
                        </el-radio-group>
                    </el-descriptions-item>
                    <el-descriptions-item label="关联商机" v-if="Orders_Type === 0 || Orders_Type === 1">
                        <div>
                            <el-input v-model="Pipeline_Key" name="Pipeline_Key" autocomplete="on"
                                placeholder="请输入工程项目名称关键词、申报单号进行检索" clearable class="el-select-big"></el-input>
                            <el-button type="primary" style="margin-left: 10px"
                                @click="get_PipelineApply_SearchList()">查询</el-button>
                            <div class="content_Pipeline" style="" v-if="PipelineCustomer.ID">
                                <div>
                                    <span class="content_title">项目信息：</span>
                                    [{{ PipelineCustomer.opportunityName }}] {{ PipelineCustomer.projectName }} [{{
                                        PipelineCustomer.industry1 }}
                                    <span v-if="PipelineCustomer.industry2">-{{ PipelineCustomer.industry2 }}</span>
                                    ]
                                </div>
                                <div>
                                    <span class="content_title">项目阶段：</span>
                                    {{ PipelineCustomer.stageName }}
                                </div>
                                <div>
                                    <span class="content_title">预计项目金额：</span>
                                    {{ PipelineCustomer.money }}
                                </div>
                                <div>
                                    <span class="content_title">项目类型：</span>
                                    {{ PipelineCustomer.entityType }}
                                </div>
                                <div>
                                    <span class="content_title">需货时间：</span>
                                    {{ PipelineCustomer.demandDate }}
                                </div>
                                <div>
                                    <span class="content_title">创建日期：</span>
                                    {{ PipelineCustomer.createdAt }}
                                </div>
                                <div>
                                    <span class="content_title">客户名称：</span>
                                    ({{ PipelineCustomer.erpid }}){{ PipelineCustomer.accountName }}
                                </div>
                                <div>
                                    <span class="content_title">联系人：</span>
                                    {{ PipelineCustomer.contact }}
                                </div>
                                <div>
                                    <span class="content_title">所有人：</span>
                                    {{ PipelineCustomer.userName }}
                                </div>
                                <div>
                                    <span class="content_title">项目地址：</span>
                                    {{ PipelineCustomer.province }} {{ PipelineCustomer.city }} {{ PipelineCustomer.area
                                    }} {{ PipelineCustomer.address }}
                                </div>
                            </div>
                        </div>
                    </el-descriptions-item>
                    <el-descriptions-item label="关联报价单" v-if="Orders_Type === 0 && changeOrderType == 0">
                        <el-input v-model="Customer_info.spc_keyword" name="projectname" autocomplete="on"
                            placeholder="请输入工程项目名称关键词、报价单号进行检索" clearable class="el-select-big"></el-input>
                        <el-button type="primary" style="margin-left: 10px"
                            @click="getSPCOrderRelationSpcApply()">查询</el-button>
                    </el-descriptions-item>
                    <el-descriptions-item label="客户类型">
                        <el-radio-group v-model="Customer_Type" @input="onChange">
                            <el-radio label="0">企业客户</el-radio>
                            <el-radio label="1">个人客户</el-radio>
                        </el-radio-group>
                    </el-descriptions-item>

                    <el-descriptions-item label="姓名" v-if="Customer_Type == 1">
                        <el-input v-model="Person_Name" autocomplete="on" name="Person_Name" placeholder="" clearable
                            class="el-select-max"></el-input>
                    </el-descriptions-item>
                    <el-descriptions-item label="手机" v-if="Customer_Type == 1">
                        <el-input v-model="Person_Mobile" autocomplete="on" name="Person_Mobile" placeholder=""
                            clearable class="el-select-max"></el-input>
                    </el-descriptions-item>
                    <el-descriptions-item label="客户名称" v-if="Customer_Type == 0">
                        <el-input v-model="Customer_Name" placeholder="请输入客户名称" name="Customer_Name" autocomplete="on"
                            clearable class="el-select-max"></el-input>
                        <el-button type="primary" style="margin-left: 10px"
                            @click="getCheckCustomerAndCustomerSub()">查询</el-button>
                    </el-descriptions-item>

                    <el-descriptions-item label="客户编号" v-if="Customer_Type == 0 && Customer_info.Customer_Code">
                        <span>{{ Customer_info.Customer_Code }}</span>
                    </el-descriptions-item>
                    <el-descriptions-item label="客户名称" v-if="Customer_Type == 0 && Customer_info.Customer_Code">
                        <span>{{ Customer_info.Customer_Name }}</span>
                        <span v-if="Customer_info.Customer_IsESign == 1" class="signature-tips">已注册电子签章</span>
                    </el-descriptions-item>
                    <el-descriptions-item label="客户类型" v-if="Customer_Type == 0 && Customer_info.Customer_Code">
                        <span>{{ Customer_Type == 0 ? '企业客户' : '个人客户' }}</span>
                    </el-descriptions-item>
                    <el-descriptions-item label="注册所在地" v-if="Customer_Type == 0 && Customer_info.Customer_Code">
                        <span>{{ Customer_info.Customer_RegAddr }}</span>
                    </el-descriptions-item>
                    <el-descriptions-item label="客户信息" v-if="Customer_Type == 0 && Customer_info.Customer_Code">
                        <div class="customers-info">
                            <el-table :data="OfficeCustomer" style="width: 1200px" border
                                :header-cell-style="{ backgroundColor: '#F5F7FA' }">
                                <el-table-column prop="Amount" label="欠款金额" align="center"></el-table-column>
                                <el-table-column prop="in0" label="未到期金额" align="center"></el-table-column>
                                <el-table-column prop="in2" label="<4个月(元)" align="center"></el-table-column>
                                <el-table-column prop="2to3" label="4-6个月(含)(元)" align="center"></el-table-column>
                                <el-table-column prop="3to5" label="6-12个月(元)" align="center"></el-table-column>
                                <el-table-column prop="up5" label=">12个月(元)" align="center"></el-table-column>
                                <el-table-column prop="score" label="信控评分" align="center"></el-table-column>
                                <el-table-column prop="actionAmount" label="未结诉讼的总金额" align="center"></el-table-column>
                                <el-table-column prop="action" label="诉讼数量" align="center"></el-table-column>
                            </el-table>
                            <el-table :data="CreditCustomer" style="width: 1200px; margin-top: 30px" border
                                :header-cell-style="{ backgroundColor: '#F5F7FA' }">
                                <el-table-column prop="RegistStute" label="注册状态" align="center"></el-table-column>
                                <el-table-column prop="ExecutedpersonCount" label="被执行人次数"
                                    align="center"></el-table-column>
                                <el-table-column prop="ExecutedpersonAmount" label="被执行人金额"
                                    align="center"></el-table-column>
                                <el-table-column prop="ExecutionListCount" label="失信被执行人次数"
                                    align="center"></el-table-column>
                                <el-table-column prop="ExecutionListAmount" label="失信被执行人金额"
                                    align="center"></el-table-column>
                                <el-table-column prop="RestrictedConsumerCount" label="限制高消费次数"
                                    align="center"></el-table-column>
                            </el-table>
                            <div class="er_Custome">
                                <div style="display: flex; align-items: center; margin-top: 20px">
                                    <h4>授权签约客户：</h4>
                                    <el-input v-model="CustomerSub_Name" placeholder="请输入客户名称" clearable
                                        class="el-select-max"></el-input>
                                    <el-button :disabled="this.Customer_info.CustomerSubs != 'True'" type="primary"
                                        style="margin-left: 10px" @click="chooseCustomerInfor()">查询</el-button>
                                </div>
                                <div v-if="sub_customerInfor.Customer_ID">
                                    <el-radio v-model="radioSub_customerInfor" text-color="#fff" label="1"
                                        style="display: flex; align-items: center; line-height: 50px">
                                        <div style="display: flex; line-height: 50px">
                                            <div style="display: flex; margin-right: 10px">
                                                <h4>客户名称：{{ sub_customerInfor.CustomerSub_Name }}</h4>
                                            </div>
                                            <div style="display: flex">
                                                <h4>客户电话：</h4>
                                                {{ sub_customerInfor.CustomerSub_Mobile }}
                                            </div>
                                        </div>
                                    </el-radio>
                                </div>
                            </div>
                        </div>
                    </el-descriptions-item>
                    <el-descriptions-item label="历史客户" v-if="Customer_Type == 0">
                        <el-radio-group v-model="Customer_ID" @input="historyChange">
                            <div class="his-customers" v-for="(item, index) in Orders_Customer" :key="index">
                                <el-radio :label="String(item.Orders_CustomerID)">{{ item.Customer_Name }}</el-radio>
                            </div>
                        </el-radio-group>
                    </el-descriptions-item>
                </el-descriptions>
                <div style="" class="customerButtom">
                    <el-button type="primary" @click="onNext()">下一步</el-button>
                </div>
            </div>
            <div class="action" v-if="next == 2 && !isReturnGoods">
                <div class="action-title">选择付款方式</div>
                <el-descriptions title="" labelClassName="custom-label">
                    <el-descriptions-item label="订单类型">{{ Orders_Type == 0 ? '销售合同' : Orders_Type == 1 ? '服务合同' : ''
                    }}</el-descriptions-item>
                    <el-descriptions-item v-if="apply_id || resultInfo.Apply_SN" label="报价单编号">{{ resultInfo.Apply_SN
                    }}</el-descriptions-item>
                    <el-descriptions-item v-if="PipelineCustomer.ID" label="商机编号">{{ PipelineCustomer.ID + ' [' +
                        PipelineCustomer.opportunityName + ']' }}</el-descriptions-item>
                    <el-descriptions-item label="客户名称" v-if="Customer_Type == 0">{{ Customer_info.Customer_Name
                    }}</el-descriptions-item>
                    <el-descriptions-item label="客户编号" v-if="Customer_Type == 0">{{ Customer_info.Customer_Code
                    }}</el-descriptions-item>
                    <el-descriptions-item label="客户姓名" v-if="Customer_Type == 1">{{ Person_Name
                    }}</el-descriptions-item>
                    <el-descriptions-item label="客户手机" v-if="Customer_Type == 1">{{ Person_Mobile
                    }}</el-descriptions-item>
                    <el-descriptions-item label="客户类型">{{ Customer_Type == 0 ? '企业客户' : '个人客户' }}</el-descriptions-item>
                    <el-descriptions-item label="注册所在地" v-if="Customer_Type == 0">{{ Customer_info.Customer_RegAddr
                    }}</el-descriptions-item>
                </el-descriptions>

                <el-descriptions title="" :column="1" labelClassName="custom-label">
                    <el-descriptions-item label="付款方式">
                        <Payment ref="Payment" :isReturnGoods="isReturnGoods" :changePayInfoData="changePayInfoData"
                            :resultInfo="resultInfo" :SPCApply_PayTypeID="SPCApply_PayTypeID"
                            :customerInfor="customerInfor" :SPCApply_PayTypeName="SPCApply_PayTypeName" />
                    </el-descriptions-item>
                </el-descriptions>
                <div class="customerButtom">
                    <el-button v-show="initialNext < next" @click="nextPayment()">上一步</el-button>
                    <el-button type="primary" @click="onNext()">下一步</el-button>
                </div>
            </div>

            <div class="action" v-if="next == 3" style="margin-bottom: 30px">
                <div class="action-title">选择商品</div>
                <el-descriptions title="" class="action">
                    <el-descriptions-item label="订单类型">{{ Orders_Type == 0 ? '销售合同' : Orders_Type == 1 ? '服务合同' : ''
                    }}</el-descriptions-item>
                    <el-descriptions-item v-if="apply_id || resultInfo.Apply_SN" label="报价单编号">{{ resultInfo.Apply_SN
                    }}</el-descriptions-item>
                    <el-descriptions-item v-if="PipelineCustomer.ID" label="商机编号">{{ PipelineCustomer.ID + ' [' +
                        PipelineCustomer.opportunityName + ']' }}</el-descriptions-item>
                    <el-descriptions-item label="客户名称" v-if="Customer_Type == 0">{{ Customer_info.Customer_Name
                    }}</el-descriptions-item>
                    <el-descriptions-item label="客户编号" v-if="Customer_Type == 0">{{ Customer_info.Customer_Code
                    }}</el-descriptions-item>
                    <el-descriptions-item label="客户姓名" v-if="Customer_Type == 1">{{ Person_Name
                    }}</el-descriptions-item>
                    <el-descriptions-item label="客户手机" v-if="Customer_Type == 1">{{ Person_Mobile
                    }}</el-descriptions-item>
                    <el-descriptions-item label="客户类型">{{ Customer_Type == 0 ? '企业客户' : '个人客户' }}</el-descriptions-item>
                    <el-descriptions-item label="注册所在地">{{ Customer_info.Customer_RegAddr }}</el-descriptions-item>
                    <el-descriptions-item label="付款方式">{{ submitpaymentObj.value }}</el-descriptions-item>
                </el-descriptions>
                <div class="tabs-container">
                    <div class="sticky-tabs">
                        <el-tabs v-model="activeName" @tab-click="handleClick">
                            <el-tab-pane label="常用商品" name="1" v-if="isReturnGoods != 1"></el-tab-pane>
                            <el-tab-pane label="普通销售件" name="2"></el-tab-pane>
                            <el-tab-pane label="控制柜配置" name="3" v-if="isReturnGoods != 1"></el-tab-pane>
                            <el-tab-pane label="壁挂式控制器" name="4" v-if="isReturnGoods != 1"></el-tab-pane>
                            <el-tab-pane label="促销活动" name="5"
                                v-if="isReturnGoods != 1 && Orders_Type == 0"></el-tab-pane>
                            <el-tab-pane label="优惠专区" name="6" v-if="Orders_Type == 1"></el-tab-pane>
                        </el-tabs>
                        <div v-show="activeName === '2'" class="sticky-form">
                            <el-form :inline="true" class="demo-form-inline">
                                <el-form-item label="选择类别">
                                    <el-select v-model="serch_productList.product_cate" placeholder=""
                                        class="el-select-medium">
                                        <el-option v-for="item in Product_cate_parentList" :key="item.Cate_ID"
                                            :label="item.Cate_Name" :value="item.Cate_ID"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="折扣分组">
                                    <el-select v-model="serch_productList.DiscounntCate" placeholder=""
                                        class="el-select-medium">
                                        <el-option v-for="item in Product_cate_DiscountList" :key="item.ID"
                                            :label="item.Name" :value="item.ID"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="选择销售组">
                                    <el-select v-model="serch_productList.SaleGroup_ID" placeholder=""
                                        class="el-select-medium">
                                        <el-option v-for="item in Product_cate_SaleGroupIDList" :key="item.SaleGroup_ID"
                                            :label="item.SaleGroup_Name" :value="item.SaleGroup_ID"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="商品名称">
                                    <el-input v-model="serch_productList.keyword" class="el-select-medium"
                                        placeholder="请输入商品名称进行搜索"></el-input>
                                </el-form-item>
                                <el-form-item>
                                    <el-button type="primary" @click="cartProductList(true)" icon="el-icon-search"
                                        :loading="loadingBtn">搜索</el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>

                    <div class="scroll-content">
                        <div v-show="activeName === '1'">
                            <el-table :data="productCommonList" ref="productCommonTable" style="width: 100%" border
                                :header-cell-style="{ backgroundColor: '#F5F7FA' }"
                                @selection-change="handleSelectionChange">
                                <el-table-column type="selection" width="55" align="center"></el-table-column>
                                <el-table-column prop="Product_Intro" label="销售组" align="center" show-overflow-tooltip
                                    width="120"></el-table-column>
                                <el-table-column prop="Product_Code" label="商品编码" align="center"
                                    width="80"></el-table-column>
                                <el-table-column prop="Product_SubName" label="商品名称" align="left" width="350">
                                    <template v-slot="scope">
                                        <div style="display: flex; align-items: center;">
                                            <img :src="getFullImageUrl(scope.row.Product_Img)"
                                                @click="showImageDetail(scope.row)" alt=""
                                                style="width: 40px; height: auto; object-fit: contain; margin-right: 5px">
                                            <span>{{ scope.row.Product_SubName }}</span>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="Product_Spec" label="规格" show-overflow-tooltip align="center"
                                    width="150"></el-table-column>
                                <el-table-column prop="Product_SupplyCycle" label="库存" align="center" width="130">
                                    <template slot="header">
                                        <span class="flex-content-center">
                                            库存
                                            <el-popover placement="top-start" title="" trigger="hover"
                                                content="库存数量非实时库存，每两小时更新一次">
                                                <span slot="reference" class="flex-content-center"><img
                                                        src="@/assets/images/wenh.png" alt=""
                                                        style="width: 15px; height: 15px; margin-left: 2px" /></span>
                                            </el-popover>
                                        </span>
                                    </template>
                                    <template slot-scope="scope">
                                        <div v-html="scope.row.Product_SupplyCycle"></div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="Product_Price" label="单价" align="center" width="100">
                                    <template v-slot="scope">
                                        <div>￥{{ scope.row.Product_Price.toFixed(2) }}</div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="prop" label="数量" align="center" width="80">
                                    <template v-slot="scope">
                                        <el-input v-model="scope.row.userDefinedNum" :min="0" :max="9999999"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="prop" label="操作" align="center" width="100">
                                    <template v-slot="scope">
                                        <div class="operation-bar">
                                            <span class="operation-bar-block operation-bar-block-del"
                                                @click="addeQuipment('del', scope.row)">移除常用设备</span>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="prop" label="合计" align="center" width="150">
                                    <template v-slot="scope">
                                        <div>￥{{ (scope.row.Product_Price * scope.row.userDefinedNum).toFixed(2) }}
                                        </div>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                        <div v-show="activeName === '2'" class="table-container" @scroll="handleScroll"
                            ref="tableContainer">
                            <el-table :data="productList" ref="productListTable" style="width: 100%" border
                                :header-cell-style="{ backgroundColor: '#F5F7FA' }" :row-class-name="getRowClassName"
                                @selection-change="handleSelectionChange">
                                <el-table-column type="selection" width="55" align="center"></el-table-column>
                                <el-table-column prop="Product_Intro" label="销售组" align="center" show-overflow-tooltip
                                    width="120"></el-table-column>
                                <el-table-column prop="Product_Code" label="商品编码" align="center"
                                    width="80"></el-table-column>
                                <el-table-column prop="Product_SubName" label="商品名称" align="left" width="350">
                                    <template v-slot="scope">
                                        <div style="display: flex; align-items: center;">
                                            <img :src="getFullImageUrl(scope.row.Product_Img)"
                                                @click="showImageDetail(scope.row)" alt=""
                                                style="width: 40px; height: auto; object-fit: contain; margin-right: 5px">
                                            <span>{{ scope.row.Product_SubName }}</span>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="Product_Spec" label="规格" align="center" show-overflow-tooltip
                                    width="150"></el-table-column>
                                <el-table-column prop="Product_SupplyCycle" label="库存" align="center" width="130">
                                    <template slot="header">
                                        <span class="flex-content-center">
                                            库存
                                            <el-popover placement="top-start" title="" trigger="hover"
                                                content="库存数量非实时库存，每两小时更新一次">
                                                <span slot="reference" class="flex-content-center"><img
                                                        src="@/assets/images/wenh.png" alt=""
                                                        style="width: 15px; height: 15px; margin-left: 2px" /></span>
                                            </el-popover>
                                        </span>
                                    </template>
                                    <template slot-scope="scope">
                                        <div v-html="scope.row.Product_SupplyCycle"></div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="Product_Price" label="单价" align="center" width="100">
                                    <template v-slot="scope">
                                        <div>￥{{ scope.row.Product_Price.toFixed(2) }}</div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="prop" label="数量" align="center" width="80">
                                    <template v-slot="scope">
                                        <el-input v-model="scope.row.userDefinedNum" :min="0" :max="9999999"></el-input>
                                    </template>
                                </el-table-column>

                                <el-table-column prop="prop" label="操作" align="center" width="120">
                                    <template v-slot="scope">
                                        <div class="operation-bar" v-if="scope.row.Product_Sort == 0">
                                            <span class="operation-bar-block operation-bar-block-del"
                                                @click="addeQuipment('Add', scope.row)">设置为常用设备</span>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="prop" label="合计" align="center" width="150">
                                    <template v-slot="scope">
                                        <div>￥{{ (scope.row.Product_Price * scope.row.userDefinedNum).toFixed(2) }}
                                        </div>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <div v-if="loadingMore" class="loading-more">
                                <i class="el-icon-loading"></i>
                                <span>加载中...</span>
                            </div>
                            <div v-if="noMoreData && productList.length > 0" class="no-more-data">
                                <span>没有更多数据了</span>
                            </div>
                        </div>
                        <div v-show="activeName === '3'">
                            <ControlCabinet :Orders_Type="Orders_Type" :Orders_SourceCate="Orders_SourceCate"
                                :shoppingCarts="shoppingCarts"
                                @Cart_ControlCabinetPackage_Add="Cart_ControlCabinetPackage_Add"
                                @searchShoppingCart="searchShoppingCart" ref="ControlCabinet"></ControlCabinet>
                        </div>
                        <div v-show="activeName === '4'">
                            <GetWallHanging :Orders_Type="Orders_Type" :Customerid="customerInfor.Customer_ID"
                                :Orders_SourceCate="Orders_SourceCate" :shoppingCarts="shoppingCarts"
                                @Cart_WallHanging_Add="Cart_WallHanging_Add" @searchShoppingCart="searchShoppingCart"
                                ref="GetWallHanging">
                            </GetWallHanging>
                        </div>
                        <div v-show="activeName === '5'">
                            <div class="content-head">
                                <el-form :inline="true" class="demo-form-inline">
                                    <el-form-item label="选择活动">
                                        <el-select v-model="activityParams.default_activity" placeholder=""
                                            class="el-select-medium">
                                            <el-option v-for="item in activityAmountList"
                                                :key="item.Promotion_Activity_ID" :label="item.Promotion_Activity_Title"
                                                :value="item.Promotion_Activity_ID"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="选择销售组">
                                        <el-select v-model="activityParams.SaleGroup_ID" placeholder=""
                                            class="el-select-medium">
                                            <el-option v-for="item in activity_cate_SaleGroupIDList"
                                                :key="item.SaleGroup_ID" :label="item.SaleGroup_Name"
                                                :value="item.SaleGroup_ID"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="商品名称">
                                        <el-input v-model="activityParams.keyword" class="el-select-medium"
                                            placeholder="请输入商品名称进行搜索"></el-input>
                                    </el-form-item>
                                    <el-form-item>
                                        <el-button type="primary" @click="cartActivityProductList(true)"
                                            icon="el-icon-search" :loading="loadingBtn">搜索</el-button>
                                    </el-form-item>
                                </el-form>
                                <!-- <div class="content-table-title" style="margin-bottom: 20px">
                                    <span></span>
                                    <span>
                                        <el-button type="primary" @click="getopenControlAdd()">加入商品到购物车</el-button>
                                    </span>
                                </div> -->
                            </div>
                            <el-table :data="activityProductList" ref="activityProductListTable" style="width: 100%"
                                border :header-cell-style="{ backgroundColor: '#F5F7FA' }"
                                @selection-change="handleSelectionChange">
                                <el-table-column type="selection" width="55" align="center"></el-table-column>
                                <el-table-column prop="Product_Contract" label="促销活动" align="center"
                                    width="160"></el-table-column>
                                <el-table-column prop="Product_Intro" label="销售组" show-overflow-tooltip align="center"
                                    width="120"></el-table-column>
                                <el-table-column prop="Product_Code" label="商品编码" align="center"
                                    width="80"></el-table-column>
                                <el-table-column prop="Product_SubName" label="商品名称" align="left" width="350">
                                    <template v-slot="scope">
                                        <div style="display: flex; align-items: center;">
                                            <img :src="getFullImageUrl(scope.row.Product_Img)"
                                                @click="showImageDetail(scope.row)" alt=""
                                                style="width: 40px; height: auto; object-fit: contain; margin-right: 5px">
                                            <span>{{ scope.row.Product_SubName }}</span>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="Product_Spec" label="规格" show-overflow-tooltip align="center"
                                    width="150"></el-table-column>
                                <el-table-column prop="Product_SupplyCycle" label="库存" align="center" width="130">
                                    <template slot="header">
                                        <span class="flex-content-center">
                                            库存
                                            <el-popover placement="top-start" title="" trigger="hover"
                                                content="库存数量非实时库存，每两小时更新一次">
                                                <span slot="reference" class="flex-content-center"><img
                                                        src="@/assets/images/wenh.png" alt=""
                                                        style="width: 15px; height: 15px; margin-left: 2px" /></span>
                                            </el-popover>
                                        </span>
                                    </template>
                                    <template slot-scope="scope">
                                        <div v-html="scope.row.Product_SupplyCycle"></div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="Product_Price" label="单价" align="center" width="100">
                                    <template v-slot="scope">
                                        <div>￥{{ scope.row.Product_Price.toFixed(2) }}</div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="prop" label="数量" align="center" width="80">
                                    <template v-slot="scope">
                                        <el-input v-model="scope.row.userDefinedNum" :min="0" :max="9999999"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="prop" label="合计" align="center" width="150">
                                    <template v-slot="scope">
                                        <div>￥{{ (scope.row.Product_Price * scope.row.userDefinedNum).toFixed(2) }}
                                        </div>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                        <div v-show="activeName === '6'">
                            <div class="content-head">
                                <el-form :inline="true" class="demo-form-inline">
                                    <el-form-item label="选择活动">
                                        <el-select v-model="PromotionParams.promotionid" placeholder=""
                                            class="el-select-medium">
                                            <el-option v-for="item in PromotionAmountList" :key="item.ID"
                                                :label="item.AmountLimit_Title" :value="item.ID"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="选择销售组">
                                        <el-select v-model="PromotionParams.SaleGroup_ID" placeholder=""
                                            class="el-select-medium">
                                            <el-option v-for="item in activity_cate_SaleGroupIDList"
                                                :key="item.SaleGroup_ID" :label="item.SaleGroup_Name"
                                                :value="item.SaleGroup_ID"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="商品名称">
                                        <el-input v-model="PromotionParams.keyword" class="el-select-medium"
                                            placeholder="请输入商品名称进行搜索"></el-input>
                                    </el-form-item>
                                    <el-form-item>
                                        <el-button type="primary" @click="cartActivityProductList(true)"
                                            icon="el-icon-search" :loading="loadingBtn">搜索</el-button>
                                    </el-form-item>
                                </el-form>
                                <!-- <div class="content-table-title" style="margin-bottom: 20px">
                                    <span></span>
                                    <span>
                                        <el-button type="primary" @click="getopenControlAdd()">加入商品到购物车</el-button>
                                    </span>
                                </div> -->
                            </div>
                            <el-table :data="promotionProductList" ref="promotionProductListTable" style="width: 100%"
                                border :header-cell-style="{ backgroundColor: '#F5F7FA' }"
                                @selection-change="handleSelectionChange">
                                <el-table-column type="selection" width="55" align="center"></el-table-column>
                                <el-table-column prop="Product_Intro" label="销售组" align="center"></el-table-column>
                                <el-table-column prop="Product_Code" label="商品编码" align="center"></el-table-column>
                                <el-table-column prop="Product_SubName" label="商品名称" align="center">
                                    <template v-slot="scope">
                                        <div style="display: flex; align-items: center;">
                                            <img :src="getFullImageUrl(scope.row.Product_Img)"
                                                @click="showImageDetail(scope.row)" alt=""
                                                style="width: 40px; height: auto; object-fit: contain; margin-right: 5px">
                                            <span>{{ scope.row.Product_SubName }}</span>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="Product_Spec" label="规格" align="center"></el-table-column>
                                <el-table-column prop="Product_SupplyCycle" label="库存" align="center">
                                    <template slot="header">
                                        <span class="flex-content-center">
                                            库存
                                            <el-popover placement="top-start" title="" trigger="hover"
                                                content="库存数量非实时库存，每两小时更新一次">
                                                <span slot="reference" class="flex-content-center"><img
                                                        src="@/assets/images/wenh.png" alt=""
                                                        style="width: 15px; height: 15px; margin-left: 2px" /></span>
                                            </el-popover>
                                        </span>
                                    </template>
                                    <template slot-scope="scope">
                                        <div v-html="scope.row.Product_SupplyCycle"></div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="Product_Price" label="单价" align="center"></el-table-column>
                                <el-table-column prop="prop" label="数量" align="center" width="150">
                                    <template v-slot="scope">
                                        <el-input-number v-model="scope.row.userDefinedNum" :min="0"
                                            :max="9999999"></el-input-number>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="prop" label="合计" align="center">
                                    <template v-slot="scope">
                                        <div>￥{{ (scope.row.Product_Price * scope.row.userDefinedNum).toFixed(2) }}
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="" label="操作" align="center"></el-table-column>
                            </el-table>
                        </div>
                    </div>
                </div>

                <div class="customerButtom">
                    <el-button v-show="initialNext < next" @click="next--">上一步</el-button>
                    <!-- <el-button type="primary" @click="onNext()">下一步</el-button> -->
                    <el-button type="primary" v-show="activeName != 3 && activeName != 4"
                        @click="getopenControlAdd()">加入商品到购物车</el-button>
                    <el-button type="primary" v-show="activeName == 3"
                        @click="CartControlCabinetPackageAdd()">加入配柜到购物车</el-button>
                    <el-button type="primary" v-show="activeName == 4"
                        @click="CartWallHangingAdd()">加入壁挂到购物车</el-button>
                    <el-button type="primary" @click="searchShoppingCart()">查看购物车({{ shoppingCarts }})</el-button>
                </div>
            </div>

            <div class="action" v-if="next == 4">
                <div class="content-table-title" style="padding: 20px 0">
                    <span>
                        <el-button type="primary" @click="continueShopping()">继续购买</el-button>
                        <el-button type="primary" @click="deleterChoose()">批量删除</el-button>
                        <el-button type="primary" @click="allDelete()">一键清空</el-button>
                        <el-button type="primary" @click="importExcel()"
                            v-if="(this.Orders_SourceCate == 0 || (this.Orders_SourceCate == 2 && this.Orders_Type == 0)) && this.isReturnGoods != 1">导入excel</el-button>
                    </span>
                    <span>
                        <span style="color: red; margin-right: 20px">请在此页面与顾客仔细核对采购商品信息及数量</span>
                        <el-button type="primary" :loading="cartEditing" :disabled="cartEditing" @click="goSubmit(1)"
                            v-if="(Orders_SourceCate == 0 || (Orders_SourceCate == 2 && this.Orders_Type == 0)) && this.isReturnGoods != 1">创建纸质合同</el-button>
                        <el-button type="primary" :loading="cartEditing" :disabled="cartEditing" @click="goSubmit(0)"
                            v-if="this.isReturnGoods == 1 || submitpaymentObj.id != 2">创建合同</el-button>
                    </span>
                </div>
                <ShoppingCart :Twlist="Twlist" :TradeType="TradeType" ref="ShoppingCart"
                    @selectionChange="selectionChange" @delete="listDelete" @change="officeCartGoodstmpEdit"
                    :allCartPrice="allCartPrice"></ShoppingCart>
                <div style="text-align: center; margin-top: 20px"></div>
            </div>

            <div class="action" v-show="next == 5" v-if="next >= 5">
                <div class="action-title">完善合同信息</div>
                <SubmitSpcOrder :changeOrderType="changeOrderType" @mountedEnd="submitMountedMethods()"
                    @userComputer="computerMethods" @userComputer1="computerMethods1" :Orders_Type="Orders_Type"
                    :TradeType="TradeType" :Customer_info="Customer_info" :submitpaymentObj="submitpaymentObj"
                    :isReturnGoods="isReturnGoods" :cartList="cartList" :activityCartList="activityCartList"
                    :Orders_SourceCate="Orders_SourceCate" :PipelineCustomer="PipelineCustomer"
                    :SPCApply_Status.sync="SPCApply_Status" ref="SubmitSpcOrder" :Total_Price="Total_Price"
                    :is-show-project-type="IsShowProjectType"
                    :IsHonly="IsHonly" @delete="listDelete"></SubmitSpcOrder>
                <div style="text-align: center; margin-top: 20px">
                    <el-button @click="goCarshop">上一步</el-button>
                    <el-button type="primary" v-if="SPCApply_Status == 1 || Orders_SourceCate != 0"
                        @click="saveOrder()">保存合同</el-button>
                    <el-button type="primary" @click="onNext()">下一步</el-button>
                </div>
            </div>
            <div class="action" v-if="next == 6">
                <div class="action-title">确认合同信息</div>
                <ConfirmSpcOrder :cartList="confirmCartList" :PipelineCustomer="PipelineCustomer"
                    :activityCartList="confirmActivityCartList" :Orders_Type="Orders_Type" :TradeType="TradeType"
                    :submitpaymentObj="submitpaymentObj" :Total_Price="Total_Price" :isReturnGoods="isReturnGoods"
                    :Customer_info="Customer_info" ref="ConfirmSpcOrder" :IsHonly="IsHonly"
                    :Orders_SourceCate="Orders_SourceCate" :is-show-project-type="IsShowProjectType">
                </ConfirmSpcOrder>
                <div style="text-align: center; margin-top: 20px">
                    <el-button @click="goconfirm">上一步</el-button>
                    <el-button type="primary" @click="confirmOrdersCreate()">提交合同</el-button>
                </div>
            </div>
            <!-- 商机客户列表弹窗 -->
            <el-dialog title="项目列表" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false"
                :visible.sync="dialogVisible" width="80%">
                <el-table height="450" :data="PipelineList" style="width: 100%" border
                    :header-cell-style="{ backgroundColor: '#F5F7FA' }">
                    <el-table-column align="center" width="55">
                        <template #default="{ row, index }">
                            <el-radio :label="row.ID" v-model="PipelineId">{{ index }}</el-radio>
                        </template>
                    </el-table-column>
                    <el-table-column prop="projectName" label="项目信息" align="center"></el-table-column>
                    <el-table-column prop="stageName" label="项目阶段" align="center"></el-table-column>
                    <el-table-column prop="money" label="预计项目金额" align="center"></el-table-column>
                    <el-table-column prop="entityType" label="项目类型" align="center"></el-table-column>
                    <el-table-column prop="demandDate" label="需货时间" align="center"></el-table-column>
                    <el-table-column prop="createdAt" label="创建日期" align="center"></el-table-column>
                    <el-table-column prop="accountName" label="客户名称" align="center"></el-table-column>
                    <el-table-column prop="" label="联系人" align="center"></el-table-column>
                    <el-table-column prop="userName" label="所有人" align="center"></el-table-column>
                    <el-table-column prop="city" label="项目地址" align="center"></el-table-column>
                </el-table>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="cancelDialog('Pipeline')">取 消</el-button>
                    <el-button type="primary" @click="confirmelection('Pipeline')">确 定</el-button>
                </span>
            </el-dialog>
            <!-- 关联报价单弹窗 -->
            <el-dialog title="关联报价单" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false"
                :visible.sync="dialogVisibleSpc" width="80%">
                <el-table :data="spcList" style="width: 100%" border
                    :header-cell-style="{ backgroundColor: '#F5F7FA' }">
                    <el-table-column align="center" width="55">
                        <template #default="{ row, index }">
                            <el-radio :label="row.Apply_ID" v-model="spcId">{{ index }}</el-radio>
                        </template>
                    </el-table-column>
                    <el-table-column prop="Apply_SN" label="报价单编号" align="center"></el-table-column>
                    <el-table-column prop="SPCApply_ProjectName" label="工程名称" align="center"></el-table-column>
                    <el-table-column prop="SPCApply_OfficeManName" label="业务员" align="center"></el-table-column>
                </el-table>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="cancelDialog('spc')">取 消</el-button>
                    <el-button type="primary" @click="confirmelection('spc')">确 定</el-button>
                </span>
            </el-dialog>
        </div>
        <el-dialog title="导入商品" :close-on-click-modal="false" :visible.sync="importExcelShow" width="60%">
            <div class="labelClassNameBox">
                <el-descriptions title="" :column="1" labelClassName="labelClassName" border>
                    <el-descriptions-item label="上传文件">
                        <Hwupload ref="Hwupload" @onSuccess="onSuccessExcel"></Hwupload>
                    </el-descriptions-item>
                    <el-descriptions-item label="导入文件路径">
                        <el-input v-model="carExexlFilepath" placeholder="请输入" clearable
                            class="el-select-max"></el-input>
                    </el-descriptions-item>
                </el-descriptions>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="importCartGoods()">开始导入</el-button>
            </span>
        </el-dialog>
        <ProductImg :productId="currentProductId" :visible.sync="showProductImgDialog"
            @close="showProductImgDialog = false" />
    </div>
</template>
<script>
import { cloneDeep } from 'lodash';
import Payment from '@/components/Payment/index.vue';
import ShoppingCart from '@/components/ShoppingCart/index.vue';
import ControlCabinet from '@/components/ControlCabinet/index.vue';
import GetWallHanging from '@/components/GetWallHanging/index.vue';
import SubmitSpcOrder from './components/submitSpcOrder.vue';
import ConfirmSpcOrder from './components/comfirmSpcOrder.vue';
import Hwupload from '@/components/Hwupload/indexlocal.vue';
import ProductImg from '@/components/ProductImg/index.vue';

export default {
    name: 'customOrder',
    components: {
        Payment,
        ShoppingCart,
        SubmitSpcOrder,
        ConfirmSpcOrder,
        ControlCabinet,
        GetWallHanging,
        Hwupload,
        ProductImg
    },
    data() {
        return {
            next: 0,
            initialNext: 1, //初始页码，小于这个不能点上一步
            customerInfor: {},
            sub_customerInfor: {}, // 二级客户
            radioSub_customerInfor: '1', // 二级客户
            Customer_Type: '0',
            Customer_ID: '',
            Customer_Name: '',
            Person_Name: '',
            Person_Mobile: '',
            CustomerSub_Name: '',
            keyword: '',
            Orders_IsAllFreight: 0,
            loadingBtn: false,
            Customer_info: {
                Customer_Code: '',
                Customer_IsLimitPay: '0'
            },
            serch_productList: {
                keyword: '',
                product_cate: 0,
                DiscounntCate: 0,
                SaleGroup_ID: 0
            },
            OfficeCustomer: [],
            Orders_Customer: [],
            previous: true,
            activeName: '1', //商品列表index 1常用商品 2普通销售件 3控制柜配置 4壁挂式控制器 5促销活动
            activeShopList: [], //当前项选中的商品列表
            productCommonList: [], //常用商品列表
            productList: [], //普通商品列表
            Product_cate_parentList: [{ Cate_Name: '全部分类', Cate_ID: 0 }],
            Product_cate_DiscountList: [{ Name: '全部折扣分组', ID: 0 }],
            Product_cate_SaleGroupIDList: [{ SaleGroup_Name: '全部销售组', SaleGroup_ID: 0 }],
            AllCategoryList: [], //全部分类
            // 促销活动
            activityProductList: [],
            activityAmountList: [{ Promotion_Activity_ID: -1, Promotion_Activity_Title: '选择活动' }], //促销活动选择活动
            activity_cate_SaleGroupIDList: [{ SaleGroup_Name: '全部销售组', SaleGroup_ID: 0 }], //促销活动销售组
            activityShopList: [], //促销活动选中的商品列表
            activityProductListOptions: {
                //促销活动商品列表分页器
                PageSize: 400,
                Page: 1,
                total: 0
            },
            activityParams: {
                default_activity: -1,
                SaleGroup_ID: 0,
                keyword: ''
            },
            // 优惠专区
            promotionProductList: [],
            PromotionAmountList: [{ ID: -1, AmountLimit_Title: '选择活动' }], //促销活动选择活动
            Product_cate_SaleGroupIDList: [{ SaleGroup_Name: '全部销售组', SaleGroup_ID: 0 }], //促销活动销售组
            PromotionProductListOptions: {
                //促销活动商品列表分页器
                PageSize: 400,
                Page: 1,
                total: 0
            },
            PromotionParams: {
                promotionid: -1,
                SaleGroup_ID: 0,
                keyword: ''
            },

            orders_id: -1,
            TradeType: 2, //0不清楚  1报价单 2合同(打包订单)
            Orders_SourceCate: 2, //合同来源    0报价单1合同变更2独立合同
            saleType: 0, //合同类型  0销售合同 1服务和物联网合同
            Orders_Type: '', //订单类型，0：销售合同，1：服务合同
            orders_copy: 0, //复制1

            orderTypeList: [],
            Pipeline_Key: '', //商机客户列表
            dialogVisible: false, //商机客户列表弹窗
            PipelineList: [], //商机客户列表,
            PipelineCustomer: {}, //商机客户列表,
            PipelineId: 0, //商机客户列表选中项目id
            dialogVisibleSpc: false, //关联报价单弹窗
            spcList: [], //关联报价单列表
            spcId: 0, //关联报价单选中id
            ispreview: false, //是否预览
            submitpaymentObj: {}, //提交订单支付方式

            Twlist: [], //购物车列表
            operationShow: false,
            nowCartId: [], //选中的商品id

            isini: true,
            cartgoods: '', //采购清单信息
            cartList: [], //普通商品信息
            activityCartList: [], //促销活动商品信息
            allMoney: 0, //总金额
            discountObj: {}, //折扣信息

            uploadmentList: [], //需要提交的上传列表

            SPCApply_AdderID: '', //业务员id
            nowOtherAgreement: [], //其他协议

            apply_id: '', //一键转订单id
            isReturnGoods: 0, //是否是返货合同
            allPrice: 0, //总金额
            shoppingCarts: 0, //购物车数量
            resultInfo: {}, //储存信息
            Apply_SN: '',
            ERP_SN: '',
            nowCartList: [], //选中的购物车列表
            changeOrderType: 0, // 1复制，2追加
            importExcelShow: false, //导入excel弹窗
            carExexlFilepath: '', //导入文件路径
            productListOptions: {
                //普通商品列表分页器
                PageSize: 20,
                Page: 1,
                total: 0
            },
            loadingMore: false, // 是否正在加载更多
            noMoreData: false, // 是否没有更多数据
            scrollPosition: 0, // 记录滚动位置
            JsonSPCApply_ID: '', //自动关联合同的id
            CreditCustomer: [], //信用客户
            changePayInfoData: {}, //付款方式
            SPCApply_PayTypeID: '', //付款方式id
            Total_Price: 0, //总金额
            allCartPrice: 0, //购物车总金额
            SPCApply_PayTypeName: '', //付款方式名称
            // 完善页与确认页的购物车分开展示
            confirmCartList: [], // 确认页购物车列表
            confirmActivityCartList: [], // 确认页促销活动购物车列表
            isConfirmCart: 0, //是否为确认页购物车
            SPCApply_Status: 0,
            cartEditing: false,
            hidePage: false,
            IsHonly: 0,
            IsShowProjectType: false,
            showProductImgDialog: false,
            currentProductId: '',
            pageLoadingInstance: null,
        };
    },
    created() {
        this.openPageLoading();
        if (this.$route.query.pipelinecode) {
            this.Pipeline_Key = this.$route.query.pipelinecode;
            this.Orders_Type = 0;
            this.get_PipelineApply_SearchList();
        }
        this.disposequeryID(this.$route.query);
        this.next = this.next == 0 ? 1 : this.next;
    },
    mounted() {
        this.getCheckSPCOrderCreate();
        this.getHistoryCustomerList();
        this.$store.dispatch('fetchLocationData');
    },
    watch: {
        next(newVal, oldval) {
            if (newVal != oldval) {
                this.$nextTick(() => {
                    try {
                        this.$refs.scrollbar.scrollTop = 0;
                    } catch (e) { }
                });
            }

            if (newVal && newVal === 3) {
                this.cartProductCountAmount();
            }
        },
        // 监听分页变化，恢复滚动位置
        'productListOptions.Page'(newVal, oldVal) {
            if (newVal > 1 && this.scrollPosition > 0) {
                this.$nextTick(() => {
                    try {
                        if (this.$refs.tableContainer) {
                            this.$refs.tableContainer.scrollTop = this.scrollPosition;
                        }
                    } catch (e) {
                        console.error('恢复滚动位置失败:', e);
                    }
                });
            }
        }
    },
    methods: {
        CartWallHangingAdd() {
            this.$refs.GetWallHanging.Cart_WallHanging_Add();
        },
        CartControlCabinetPackageAdd() {
            this.$refs.ControlCabinet.Cart_ControlCabinetPackage_Add();
        },

        async disposequeryID(params) {
            this.openPageLoading();
            let handled = false;
            for (const [key, value] of Object.entries(params)) {
                switch (key) {
                    case 'id':
                        handled = true;
                        this.hidePage = true;
                        console.log('合同修改');
                        this.orders_id = value;
                        this.changeOrder();
                        break;
                    case 'applyId':
                        handled = true;
                        console.log('一键转合同');
                        this.hidePage = true;
                        this.apply_id = value;

                        if (this.$store.state.order.applyStatus == 1) {
                            this.next = 4;
                            this.initialNext = 4;
                            await this.getSPCApplyToSPCOrdersCheck();
                            await this.disposeSPCmethods();
                        } else {
                            await this.getSPCApplyToSPCOrdersCheck();
                            this.next = 2;
                            this.initialNext = 2;
                        }
                        this.Orders_SourceCate = 0;
                        await this.$nextTick();
                        this.closePageLoading();
                        break;
                    case 'returnGoodsId':
                        handled = true;
                        console.log('创建返货合同');
                        this.hidePage = true;
                        this.apply_id = value;
                        this.isReturnGoods = 1;
                        this.getReturnGoodsToSPCOrdersCheck();
                        this.Orders_SourceCate = 0;
                        break;
                    case 'CopyId':
                        handled = true;
                        console.log('复制追加');
                        this.changeOrderType = this.$route.query.submitChangeOrderTypes;
                        if (this.changeOrderType == 2) {
                            this.hidePage = true;
                        }
                        if (this.changeOrderType == 1) {
                            this.orders_id = this.$route.query.CopyId;
                        } else {
                            this.apply_id = this.$route.query.CopyId;
                        }
                        this.orders_copy = this.changeOrderType == 1 ? 1 : 0;
                        this.getCopyOrders();
                        break;
                    default:
                        console.log('创建合同');
                }
            }
            if (!handled) {
                await this.$nextTick();
                this.closePageLoading();
            }
        },
        // 处理一键转合同为跳过选择客户页面直达购物车页面
        async disposeSPCmethods() {
            await this.cartProductCommonList();
            await this.UpdateCartSession();
            await this.searchShoppingCart();
        },
        //付款方式
        paymentMethod(e) {
            let code = JSON.parse(e.SPCApply_PayTypeNameJson);
            code.secondpay_days = code.second_days;
            this.submitpaymentObj.id = e.SPCApply_PayTypeID;
            this.submitpaymentObj.value = e.SPCApply_PayTypeName;
            this.submitpaymentObj.needPayCode = code;
            this.changePayInfoData = this.submitpaymentObj.needPayCode;
            this.SPCApply_PayTypeID = e.SPCApply_PayTypeID;
            this.SPCApply_PayTypeName = e.SPCApply_PayTypeName;

            // 等待组件挂载完成后再调用组件方法
            this.$nextTick(() => {
                if (this.$refs.Payment) {
                    this.$refs.Payment.changePayInfo(this.SPCApply_PayTypeID);
                }
            });
        },
        // 一键转订单
        async getSPCApplyToSPCOrdersCheck(e) {
            let { data: result } = await this.$newsApi.order.getSPCApplyToSPCOrdersCheck({
                applyid: this.apply_id,
                Type: 0
            });
            if (result.Resultcode != 0) {
                await this.$alert(result.Resultinfo, '提示', {
                    confirmButtonText: '确定',
                    type: 'warning'
                });
                this.Customer_info.spc_keyword = '';
                return false;
            } else {
                this.previous = false;
                let resultInfo = result.data;
                this.resultInfo = resultInfo;
                this.paymentMethod(resultInfo);
                let { data: customerInfo } = await this.$newsApi.order.getCheckCustomerAndCustomerSub({
                    Orders_Type: resultInfo.Orders_Type, //订单类型
                    Customer_Type: resultInfo.Customer_Type || '', //客户类型
                    Customer_ID: resultInfo.SPCApply_CustomerID || 0, //客户ID
                    Customer_Name: resultInfo.SPCApply_CustomerName || '', //客户名称
                    Customer_Sub_ID: resultInfo.SPCApply_CustomerSubID || 0, //二级客户ID
                    CustomerSub_Name: resultInfo.SPCApply_CustomerSubName || '', //二级客户名称
                    Person_Name: resultInfo.SPCApply_CustomerName || '', //个人姓名
                    Person_Mobile: resultInfo.SPCApply_CustomerMobile || '', //个人电话
                    OrdersID: resultInfo.OrdersID
                });
                await this.$newsApi.order.SetIniSPCOrdersGoods_To_GoodsTmp({
                    Apply_ID: resultInfo.Apply_ID,
                    Apply_SN: resultInfo.Apply_SN,
                    Customer_ID: customerInfo.data.Customer_ID,
                    Customer_SubID: customerInfo.data.Customer_Sub_ID || 0,
                    BuyerID: customerInfo.data.Member_ID,
                    Orders_Type: 0,
                    Apply_Status: resultInfo.SPCApply_Status
                });
                // 存贮客户信息
                this.Orders_Type = 0;
                this.Customer_info = customerInfo.data;
                this.Customer_info.Customer_SubID = customerInfo.data.Customer_Sub_ID || 0;
                this.saveCustomerInfo();
                if (e) {
                    return true;
                }
            }
        },
        // 创建返货订单
        async getReturnGoodsToSPCOrdersCheck() {
            let json = JSON.stringify({
                returngoods: this.isReturnGoods
            });
            let { data: result } = await this.$newsApi.order.getSPCApplyToSPCOrdersCheck({
                applyid: this.apply_id,
                Type: 0,
                json: json

            });
            if (result.Resultcode != 0) {
                this.$alert(result.Resultinfo, '提示', {
                    confirmButtonText: '确定',
                    type: 'warning'
                }).then(() => {
                    this.Customer_info.spc_keyword = '';
                    return;
                });
            }
            this.previous = false;
            let resultInfo = result.data;
            this.resultInfo = resultInfo;
            let { data: customerInfo } = await this.$newsApi.order.getCheckCustomerAndCustomerSub({
                Orders_Type: resultInfo.Orders_Type, //订单类型
                Customer_Type: resultInfo.Customer_Type || '', //客户类型
                Customer_ID: resultInfo.SPCApply_CustomerID || 0, //客户ID
                Customer_Name: resultInfo.SPCApply_CustomerName || '', //客户名称
                Customer_Sub_ID: resultInfo.SPCApply_CustomerSubID || 0, //二级客户ID
                CustomerSub_Name: resultInfo.SPCApply_CustomerSubName || '', //二级客户名称
                Person_Name: resultInfo.SPCApply_CustomerName || '', //个人姓名
                Person_Mobile: resultInfo.SPCApply_CustomerMobile || '', //个人电话
                OrdersID: resultInfo.OrdersID
            });
            // 存贮客户信息
            this.Orders_Type = 0;
            this.Customer_info = customerInfo.data;
            this.Customer_info.Customer_SubID = customerInfo.data.Customer_Sub_ID || 0;
            this.saveCustomerInfo();
            this.paymentMethod(resultInfo);
            this.activeName = '2';
            this.handleClick('2');
            if (this.customerInfor.SPCApply_PayTypeID == '8' || this.customerInfor.SPCApply_PayTypeID == '9') {
                this.next = 2;
                this.initialNext = 2;
            } else {
                await this.UpdateCartSession();
                this.next = 3;
                this.initialNext = 3;
            }
            await this.$nextTick();
            this.closePageLoading();
        },
        // 修改合同
        async changeOrder() {
            if (this.$route.query.changeIsReturnGoods == 1) {
                this.isReturnGoods = 1;
            }
            this.previous = false;
            // 检查订单
            let { data: result } = await this.$newsApi.order.SPCOrders_Edit_Check({
                ordersid: this.orders_id
            });
            this.Orders_SourceCate = result.data.Orders_SourceCate;
            if (result.data.Orders_SourceCate == 1) {
            } else {
                // 查找客户信息
                let resultInfo = result.data;
                this.resultInfo = resultInfo;
                let { data: customerInfo } = await this.$newsApi.order.getCheckCustomerAndCustomerSub({
                    Orders_Type: resultInfo.Orders_Type, //订单类型
                    Customer_Type: resultInfo.Customer_Type || '', //客户类型
                    Customer_ID: resultInfo.SPCApply_CustomerID || 0, //客户ID
                    Customer_Name: resultInfo.SPCApply_CustomerName || '', //客户名称
                    Customer_Sub_ID: resultInfo.SPCApply_CustomerSubID || 0, //二级客户ID
                    CustomerSub_Name: resultInfo.SPCApply_CustomerSubName || '', //二级客户名称
                    Person_Name: resultInfo.SPCApply_CustomerName || '', //个人姓名
                    Person_Mobile: resultInfo.SPCApply_CustomerMobile || '', //个人电话
                    OrdersID: resultInfo.OrdersID
                });
                // 存贮客户信息
                this.Orders_Type = Number(resultInfo.Orders_TradeType);
                this.Customer_info = customerInfo.data;
                this.Customer_info.Customer_SubID = customerInfo.data.Customer_Sub_ID || 0;
                this.saveCustomerInfo();
                this.paymentMethod(resultInfo);
                if (this.isReturnGoods == 1) {
                    this.activeName = '2';
                    this.handleClick('2');
                }
                if (resultInfo.SPCApply_PayTypeID != '8' && resultInfo.SPCApply_PayTypeID != '9' && this.isReturnGoods == 1) {
                    await this.UpdateCartSession();
                    this.next = 3;
                    this.initialNext = 3;
                } else {
                    this.next = 2;
                    this.initialNext = 2;
                }
            }
            await this.$nextTick();
            this.closePageLoading();
        },
        // 复制合同
        async getCopyOrders() {
            // 检查订单
            let { data: result } = await this.$newsApi.order.GetSPCOrdersCopyByOrders({
                Orders_id: this.$route.query.CopyId,
                Orders_Copy: this.changeOrderType == 1 ? 1 : 0
            });
            this.Apply_SN = result.data.Apply_SN;
            this.ERP_SN = result.data.ERP_SN;
            this.Orders_SourceCate = result.data.Orders_SourceCate;
            if (result.data.Orders_SourceCate == 1) {
            } else {
                // 查找客户信息
                let resultInfo = result.data;
                resultInfo.SPCOrders_ID = this.changeOrderType == 1 ? resultInfo.SPCOrders_ID : 0;
                this.resultInfo = resultInfo;
                let { data: customerInfo } = await this.$newsApi.order.getCheckCustomerAndCustomerSub({
                    Orders_Type: resultInfo.Orders_Type, //订单类型
                    Customer_Type: resultInfo.Customer_Type || '', //客户类型
                    Customer_ID: resultInfo.SPCApply_CustomerID || 0, //客户ID
                    Customer_Name: resultInfo.SPCApply_CustomerName || '', //客户名称
                    Customer_Sub_ID: resultInfo.SPCApply_CustomerSubID || 0, //二级客户ID
                    CustomerSub_Name: resultInfo.SPCApply_CustomerSubName || '', //二级客户名称
                    Person_Name: resultInfo.SPCApply_CustomerName || '', //个人姓名
                    Person_Mobile: resultInfo.SPCApply_CustomerMobile || '', //个人电话
                    OrdersID: resultInfo.OrdersID
                });
                if (this.changeOrderType != 1) {
                    await this.$newsApi.order.SetIniSPCOrdersGoods_To_GoodsTmp({
                        Apply_ID: resultInfo.Apply_ID,
                        Apply_SN: resultInfo.Apply_SN,
                        Customer_ID: customerInfo.data.Customer_ID,
                        Customer_SubID: customerInfo.data.Customer_Sub_ID || 0,
                        BuyerID: customerInfo.data.Member_ID,
                        Orders_Type: 0,
                        Apply_Status: resultInfo.SPCApply_Status
                    });
                }

                // 存贮客户信息
                this.Orders_Type = Number(resultInfo.Orders_TradeType);
                this.Customer_info = customerInfo.data;
                this.Customer_info.Customer_SubID = customerInfo.data.Customer_Sub_ID || 0;
                if (this.Customer_info) {
                    this.Customer_Name = this.Customer_info.Customer_Name;
                    this.Customer_ID = this.Customer_info.Customer_ID;
                }
                await this.getOfficeCustomerARAmount(this.Customer_info.Customer_Code);
                this.saveCustomerInfo();
                this.paymentMethod(resultInfo);
                if (this.changeOrderType == 1) {
                    this.next = 1;
                    this.initialNext = 1;
                } else {
                    await this.UpdateCartSession();
                    this.next = 2;
                    this.initialNext = 2;
                }
            }
            await this.$nextTick();
            this.closePageLoading();
        },
        // 获取打包订单合同类型
        getCheckSPCOrderCreate() {
            this.$newsApi.order.getCheckSPCOrderCreate().then((res) => {
                if (res.data.Resultcode == 0) {
                    this.orderTypeList = res.data.data;
                }
            });
        },
        openPageLoading() {
            if (!this.pageLoadingInstance) {
                this.pageLoadingInstance = this.$loading();
            }
        },
        closePageLoading() {
            if (this.pageLoadingInstance) {
                this.$closeLoading(this.pageLoadingInstance);
                this.pageLoadingInstance = null;
            }
        },
        // 打包订单合同类型改变
        changeSPCOrderCreate() {
            this.orderTypeList.forEach((item, index) => {
                if (this.Orders_Type == item.ID) {
                    if (item.tip) {
                        this.$message.warning(item.tip);
                    }
                }
            });
        },
        /*
        客户选择
        */
        async getCheckCustomerAndCustomerSub() {
            this.sub_customerInfor = {};
            this.CustomerSub_Name = '';
            let result = { Orders_Type: this.Orders_Type, Customer_Type: this.Customer_Type };
            if (this.Customer_Type == 0) {
                result = {
                    ...result,
                    Customer_ID: 0,
                    Customer_Name: this.Customer_Name
                };
            } else {
                result = {
                    ...result,
                    Person_Name: this.Person_Name,
                    Person_Mobile: this.Person_Mobile
                };
            }
            let res = await this.$newsApi.order.getCheckCustomerAndCustomerSub(result);
            if (res.data.Resultcode == 0 && res.data.data != null) {
                console.log('res.data.data', res.data.data);
                this.Customer_info = res.data.data;
                this.Customer_info.Customer_SubID = res.data.data.Customer_Sub_ID || 0;
                if (this.Customer_Type == 0) {
                    this.Customer_info.Customer_Name = this.Customer_Name;
                } else {
                    this.Customer_info.Customer_Name = this.Person_Name;
                }
                await this.getOfficeCustomerARAmount(this.Customer_info.Customer_Code);
                await this.GetCreditCustomerRisk(this.Customer_info.Customer_Code, this.Customer_info.Customer_Name);
                if (this.Customer_Type == 0 && this.Customer_info.customer_islimit == '1') {
                    this.$confirm('此客户为受限客户，将触发BPM审核流程！', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    })
                        .then(() => {
                            // this.currentCustomerInfor.Pipeline_ID = this.currentPipelineInfor[this.currentPipelineId].opportunityName
                            // 	this.currentCustomerInfor.Apply_ID = this.currentPipelineInfor[this.currentPipelineId].ID
                            // 	this.currentCustomerInfor.currentPipelineList = this.currentPipelineInfor[this.currentPipelineId]
                        })
                        .catch(() => {
                            location.reload();
                        });
                } else {
                    // this.currentCustomerInfor.Pipeline_ID = this.currentPipelineInfor[this.currentPipelineId].opportunityName
                    // this.currentCustomerInfor.Apply_ID = this.currentPipelineInfor[this.currentPipelineId].ID
                    // this.currentCustomerInfor.currentPipelineList = this.currentPipelineInfor[this.currentPipelineId]
                }
            }
        },
        //二级客户查询
        chooseCustomerInfor() {
            if (!this.CustomerSub_Name) {
                this.$message({
                    type: 'warning',
                    message: '二级客户名称不能为空'
                });
                return;
            }
            this.$newsApi.order
                .getCheckCustomerAndCustomerSub({
                    Orders_Type: this.Orders_Type, //订单类型
                    Customer_Type: this.Customer_Type, //客户类型
                    Customer_ID: this.Customer_info.Customer_ID, //客户ID
                    Customer_Name: this.Customer_info.Customer_Name, //客户名称
                    Customer_Sub_ID: 0, //二级客户ID
                    CustomerSub_Name: this.CustomerSub_Name, //二级客户名称
                    OrdersID: 0
                })
                .then((res) => {
                    if (res.data.Resultcode == 0) {
                        this.sub_customerInfor = res.data.data;
                    } else {
                        this.sub_customerInfor = {};
                    }
                });
        },
        onChange(e) {
            // 每次切换重置
            // this.Customer_info = {};
            // this.Customer_ID = '';
            // this.Customer_Name = '';
            // this.Person_Name = '';
            // this.Person_Mobile = '';
            // this.CustomerSub_Name = '';
        },
        historyChange() {
            const object = this.Orders_Customer.find((item) => item.Orders_CustomerID == this.Customer_ID);
            if (object) {
                this.Customer_Name = object.Customer_Name;
                this.getCheckCustomerAndCustomerSub();
            }
        },
        // 获取客户信用
        async getOfficeCustomerARAmount(e) {
            const result = await this.$newsApi.order.getOfficeCustomerARAmount({
                CustomerCode: e || ''
            });
            if (result.data.data) {
                this.OfficeCustomer = [{ ...result.data.data }];
            } else {
                this.OfficeCustomer = [];
            }
        },
        // 获取客户被执行信息
        async GetCreditCustomerRisk(e, i) {
            const result = await this.$newsApi.order.GetCreditCustomerRisk({
                CustomerCode: e || '',
                Customer_name: i || ''
            });
            if (result.data.data) {
                this.CreditCustomer = [{ ...result.data.data }];
            } else {
                this.CreditCustomer = [];
            }
        },
        handleClick(e) {
            this.cartProductCountAmount();
            const r = this.activeName;
            if (r == 1) {
                this.cartProductCommonList();
                return;
            }
            if (r == 2) {
                this.getAllCategory();
                this.getDiscountCategorys();
                this.getSaleGroups();
                this.cartProductList();
            }
            if (r == 3) {
                // 控制柜配置
                this.$refs.ControlCabinet.GetControlCabinetProductModel();
                this.$refs.ControlCabinet.GetControlCabinetProductCanbinet();
            }
            if (r == 4) {
                this.$refs.GetWallHanging.GetModel();
                // this.GetWallHangingForm();
            }
            if (r == 5) {
                this.GetPromotionActivitys();
                this.getDiscountCategorys();
                this.cartActivityProductList();
            }
            if (r == 6) {
                this.PromotionAmountLimitSelect();
                this.getDiscountCategorys();
                this.promotionsearchList();
            }
        },

        handleChange() { },
        /*
        获取商机客户列表
        */
        get_PipelineApply_SearchList(autoSelect = false) {
            const loadingInstance = this.$loading(); // 显示 loading
            this.PipelineCustomer = {};
            this.$newsApi.order
                .get_PipelineApply_SearchList({
                    Pipeline_Key: this.Pipeline_Key,
                    Orders_Type: this.Orders_Type
                })
                .then((res) => {
                    if (res.data.Resultcode == 0) {
                        this.PipelineList = res.data.data || [];
                        if (res.data.data && this.PipelineList.length == 1) {
                            this.PipelineId = this.PipelineList[0].ID;
                            this.PipelineCustomer = this.PipelineList[0];
                            this.Customer_Name = this.PipelineList[0].accountName;
                            this.getCheckCustomerAndCustomerSub();
                            this.dialogVisible = false;
                            return;
                        }
                        if (autoSelect) {
                            const pipeline = this.PipelineList.find((item) => String(item.ID) === String(this.Pipeline_Key)) || (this.PipelineList.length === 1 ? this.PipelineList[0] : null);
                            if (pipeline) {
                                this.PipelineId = pipeline.ID;
                                this.PipelineCustomer = pipeline;
                                this.Customer_Name = pipeline.accountName;
                                this.getCheckCustomerAndCustomerSub();
                                this.dialogVisible = false;
                                return;
                            }
                        }
                        this.dialogVisible = true;
                    }
                })
                .finally(() => {
                    this.$closeLoading(loadingInstance); // 关闭 loading
                });
        },
        confirmelection(type) {
            if (type == 'Pipeline') {
                if (this.PipelineId == 0) {
                    this.$message.warning('请选择项目');
                    return;
                }
                this.PipelineCustomer = this.PipelineList.find((item) => item.ID == this.PipelineId);
                this.Customer_Name = this.PipelineCustomer.accountName;
                this.getCheckCustomerAndCustomerSub();
                this.dialogVisible = false;
            }
            if (type == 'spc') {
                if (this.spcId == 0) {
                    this.$message.warning('请选择报价单');
                    return;
                }
                this.$confirm('是否选择当前客户进行下一步操作？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(async () => {
                        this.dialogVisibleSpc = false;
                        // 开始一键转合同
                        this.apply_id = this.spcId;
                        this.Orders_SourceCate = 2;
                        // 检查转换结果,如果返回false则终止后续操作
                        const checkResult = await this.getSPCApplyToSPCOrdersCheck(true);
                        if (!checkResult) {
                            this.spcId = 0;
                            return;
                        }
                        else {
                            this.Orders_SourceCate = 0;
                        }


                        this.next++;
                    })
                    .catch((e) => {
                        console.log(e);
                        this.spcId = 0;
                    });
            }
        },
        // 取消弹窗
        cancelDialog(type) {
            if (type == 'Pipeline') {
                this.dialogVisible = false;
                this.PipelineId = 0;
            }
            if (type == 'spc') {
                this.dialogVisibleSpc = false;
                this.spcId = 0;
            }
        },
        // 获取商关联报价单
        getSPCOrderRelationSpcApply() {
            const loadingInstance = this.$loading(); // 显示 loading
            this.$newsApi.order
                .getSPCOrderRelationSpcApply({
                    ordersn: this.Customer_info.spc_keyword
                })
                .then((res) => {
                    if (res.data.Resultcode == 0) {
                        this.dialogVisibleSpc = true;
                        this.spcList = res.data.data;
                    }
                })
                .finally(() => {
                    this.$closeLoading(loadingInstance); // 关闭 loading
                });
        },
        /*获取历史客户列表*/
        getHistoryCustomerList() {
            // const loadingInstance = this.$loading(); // 显示 loading
            this.$newsApi.order.getHistoryCustomerList().then((res) => {
                if (res.data.Resultcode == 0) {
                    this.Orders_Customer = res.data.data;
                }
                // this.$closeLoading(loadingInstance); //
            });
        },
        // 获取常用商品
        async cartProductCommonList() {
            const result = await this.$newsApi.order.getCartProductCommonList({
                Orders_type: this.Orders_Type,
                json: {}
            });
            if (result.data.data) {
                result.data.data.map((item) => {
                    // console.log(item)
                    (item.userDefinedNum = 0), (item.checkBox = false);
                });
                this.productCommonList = result.data.data;

                this.$nextTick(() => {
                    // 或者选中所有行
                    if (this.next == 3) {
                        this.productCommonList.forEach((row) => {
                            // this.activeShopList = row;
                            this.$refs.productCommonTable.toggleRowSelection(row, true);
                        });
                    }
                });
            } else {
                this.productCommonList = [];
            }
        },
        // 获取商品分类
        async getAllCategory(e) {
            let result = await this.$newsApi.getAllCategory();
            let arr = result.data.data.filter((item) => item.Cate_ParentID == 0);
            this.Product_cate_parentList = [{ Cate_Name: '全部分类', Cate_ID: 0 }].concat(arr);
            this.AllCategoryList = result.data.data;
        },
        // 获取商品销售类型
        async getDiscountCategorys() {
            let result = await this.$newsApi.getDiscountCategorys();
            this.Product_cate_DiscountList = [{ Name: '全部折扣分组', ID: 0 }].concat(result.data.data);
        },
        // 获取销售组
        async getSaleGroups() {
            let result = await this.$newsApi.order.getSaleGroups();
            this.Product_cate_SaleGroupIDList = [{ SaleGroup_Name: '全部销售组', SaleGroup_ID: 0 }].concat(result.data.data);
            this.activity_cate_SaleGroupIDList = [{ SaleGroup_Name: '全部销售组', SaleGroup_ID: 0 }].concat(result.data.data);
        },
        // 获取促销活动
        async GetPromotionActivitys() {
            try {
                var result = await this.$newsApi.order.GetPromotionActivitys();
                // 检查返回数据是否有效
                if (result && result.data && result.data.data && Array.isArray(result.data.data)) {
                    // 过滤掉null或undefined的项目
                    const validData = result.data.data.filter(item => item && item.Promotion_Activity_ID !== null && item.Promotion_Activity_ID !== undefined);
                    this.activityAmountList = [{ Promotion_Activity_ID: -1, Promotion_Activity_Title: '选择活动' }].concat(validData);
                } else {
                    // 如果没有有效数据，只保留默认选项
                    this.activityAmountList = [{ Promotion_Activity_ID: -1, Promotion_Activity_Title: '选择活动' }];
                }
            } catch (error) {
                console.error('获取促销活动失败:', error);
                // 出错时保持默认选项
                this.activityAmountList = [{ Promotion_Activity_ID: -1, Promotion_Activity_Title: '选择活动' }];
            }
        },
        // 获取促销活动
        async PromotionAmountLimitSelect() {
            var result = await this.$newsApi.order.PromotionAmountLimitSelect();
            this.PromotionAmountList = [{ ID: -1, AmountLimit_Title: '选择活动' }].concat(result.data.data || []);
        },
        // 普通商品列表
        async cartProductList(e, isLoadMore = false) {
            if (e && !isLoadMore) {
                this.productListOptions = {
                    PageSize: 20,
                    Page: 1,
                    total: 0
                };
                this.productList = [];
                this.noMoreData = false;
                this.scrollPosition = 0;
            }

            if (this.loadingMore) return;

            this.loadingMore = true;

            let jsonData = { ...this.serch_productList, promotionid: 0, IsActivity: 0 };
            if (this.isReturnGoods == 1) {
                jsonData.returngoods = 1;
            }
            if (this.apply_id > 0) {
                jsonData.ApplyID = this.apply_id;
            }
            jsonData = JSON.stringify(jsonData);

            let loadingInstance = !isLoadMore ? this.$loading() : null;

            try {
                let result = await this.$newsApi.order.getCartProductList({
                    Orders_type: this.Orders_Type,
                    Json: jsonData,
                    Page: this.productListOptions.Page,
                    PageSize: this.productListOptions.PageSize
                });

                if (loadingInstance) {
                    this.$closeLoading(loadingInstance);
                }

                if (result.data.data && result.data.data.length > 0) {
                    // 添加默认数量属性
                    result.data.data.map((item) => {
                        (item.userDefinedNum = 0), (item.checkBox = true);
                    });

                    if (isLoadMore) {
                        // 记录当前滚动位置
                        if (this.$refs.tableContainer) {
                            this.scrollPosition = this.$refs.tableContainer.scrollTop;
                        }

                        // 为新加载的数据添加分隔标识
                        if (this.productList.length > 0) {
                            result.data.data[0].isNewBatch = true;
                            console.log('设置新批次标识:', result.data.data[0]);
                        }
                        // 瀑布流加载更多，追加数据
                        this.productList = this.productList.concat(result.data.data);

                        // 恢复滚动位置
                        this.$nextTick(() => {
                            if (this.$refs.tableContainer && this.scrollPosition > 0) {
                                this.$refs.tableContainer.scrollTop = this.scrollPosition;
                            }
                        });
                    } else {
                        // 首次加载或搜索，替换数据
                        this.productList = result.data.data;
                    }

                    this.productListOptions.total = result.data.total;

                    // 检查是否还有更多数据
                    if (this.productList.length >= result.data.total) {
                        this.noMoreData = true;
                    }

                    this.$nextTick(() => {
                        // 选中所有行
                        this.productList.forEach((row) => {
                            this.$refs.productListTable.toggleRowSelection(row, true);
                        });
                    });
                } else {
                    if (!isLoadMore) {
                        this.productList = [];
                    }
                    this.noMoreData = true;
                }
            } catch (error) {
                if (loadingInstance) {
                    this.$closeLoading(loadingInstance);
                }
                console.error('加载商品列表失败:', error);
            } finally {
                this.loadingMore = false;
            }
        },
        // 当前选中的数组
        handleSelectionChange(value) {
            this.activeShopList = value;
        },
        /*保存合同*/
        saveOrder() {
            this.$confirm('订单将保存，不会提交，是否继续？', '提示', {
                confirmButtonText: '是',
                cancelButtonText: '否',
                type: 'warning'
            }).then(() => {
                this.OrdersCreate({ name: '保存', type: 0 });
            });
        },
        /*下一步*/
        async onNext() {
            switch (this.next) {
                case 1:
                    // 如果是个人客户需要手动检查
                    if (this.Customer_Type == 1) {
                        var reg = /^[1](([3][0-9])|([4][0,1,4-9])|([5][0-3,5-9])|([6][2,5,6,7])|([7][0-8])|([8][0-9])|([9][0-3,5-9]))[0-9]{8}$/; //手机号验证规则
                        if (this.Person_Name == '') {
                            this.$message.warning('请输入客户姓名');
                            return;
                        } else if (this.Person_Mobile == '') {
                            this.$message.warning('请输入客户手机号');
                            return;
                        } else if (!reg.test(this.Person_Mobile)) {
                            this.$message.warning('客户手机号格式错误');
                            return;
                        } else {
                            await this.getCheckCustomerAndCustomerSub();
                            this.saveCustomerInfo();
                            this.next++;
                        }
                    } else {
                        this.isNeedAddCustomerSub();
                    }

                    if (this.apply_id == 0 && this.Orders_SourceCate == 0) {
                        this.Orders_SourceCate = 2;
                    }
                    break;

                case 2:
                    // 支付方式
                    let result = await this.$refs.Payment.nextStep();
                    if (this.orders_id != -1) {
                        await this.$refs.Payment.ClearSPCOrdersGoodsTmpByOrdersID({ Orders_ID: this.orders_id, orderType: this.Orders_Type });
                    }
                    this.submitpaymentObj = result;
                    this.submitpaymentObj.needPayCode = this.submitpaymentObj.needPayCode || {};
                    if (result) {
                        this.cartProductCommonList();
                        this.UpdateCartSession();
                        this.next++;
                        this.activeName = '1';
                    }
                    setTimeout(() => {
                        this.cartProductCountAmount();
                    }, 500);
                    break;
                case 3:
                    break;
                case 5:
                    this.Orders_IsAllFreight = 0;  // 下一步之前先重置一下是否3000受限
                    this.OrdersCreate({ name: '下一步', type: 1 });
                    break;
            }
        },
        // 更新购物车sessionid
        async UpdateCartSession() {
            let ordersId = this.changeOrderType == 0 ? this.orders_id : '-1';
            var result = await this.$newsApi.order.UpdateCartSession({
                orders_buyerid: this.customerInfor.Member_ID,
                orders_id: ordersId,
                tradetype: this.TradeType
            });
        },
        // 下一步点击之前校验
        beforeNextCheck() {
            let Orders_Type = this.Orders_Type.toString();
            if (!Orders_Type) {
                this.$message.warning('请选择订单类型');
                return;
            }
            if (!this.Customer_info.Customer_Code) {
                this.$message.warning('请选择客户');
                return;
            }
            return true;
        },
        //是否需要添加二级客户
        isNeedAddCustomerSub() {
            if (!this.beforeNextCheck()) {
                return;
            }
            this.saveCustomerInfo();
            if (this.Orders_Type == 0 && this.customerInfor.CustomerSubs == true) {
                this.$confirm('是否选择二级客户？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '否',
                    type: 'warning'
                })
                    .then(() => {
                        this.$message({
                            type: 'warning',
                            message: '暂不支持选择二级客户'
                        });
                    })
                    .catch(() => {
                        this.next++;
                    })
                    .finally(() => { });
            } else {
                this.next++;
            }
        },
        // 储存当前选择的客户信息
        saveCustomerInfo() {
            this.customerInfor = cloneDeep({
                ...this.Customer_info,
                TradeType: this.TradeType,
                Orders_type: this.Orders_Type
            });
            this.Customer_Type = '' + this.customerInfor.Customer_Type;
            if (this.Customer_Type == 1) {
                this.Person_Name = this.customerInfor.Person_Name;
                this.Person_Mobile = this.customerInfor.Person_Mobile;
            }
        },
        //添加购物车
        async getopenControlAdd() {
            let obj = {};
            var shopList = [];
            let IsActivity = 0;
            if (this.activeName == 1) {
                // shopList = this.productCommonList;
            } else if (this.activeName == 2) {
                // shopList = this.productList;
            } else if (this.activeName == 5) {
                if (this.TradeType == 2 && this.$store.state.saleType == 1) {
                    // shopList = this.promotionProductList;
                } else {
                    shopList = this.activityProductList;
                    IsActivity = 1;
                }
            }
            for (let i = 0; i < this.activeShopList.length; i++) {
                let currentObj = this.activeShopList[i];
                if (currentObj.userDefinedNum > 0) {
                    obj[currentObj.Product_ID] = currentObj.userDefinedNum;
                }
            }
            if (JSON.stringify(obj) == '{}') {
                this.$message.warning('请您选择商品并添加数量');
            } else {
                const loadingInstance = this.$loading(); // 显示 loading
                obj = JSON.stringify(obj);
                var result = await this.cartProductBatchAdd(obj, IsActivity);
                this.$closeLoading(loadingInstance); // 关闭 loading
                if (result.data.resultcode == 0) {
                    this.$message.success(result.data.resultinfo);
                    this.cartProductCountAmount();
                }
            }
        },
        // 购物车请求
        async cartProductBatchAdd(e, isactivity) {
            let ordersId = this.changeOrderType == 0 ? this.orders_id : '-1';
            let dataObj = {
                orders_type: this.Orders_Type, //订单类型
                customer_id: this.customerInfor.Customer_ID || 0, //客户ID
                customer_subid: this.customerInfor.Customer_Sub_ID || 0, //二级客户ID
                buyerid: this.customerInfor.Member_ID,
                sessionid: '',
                tradetype: this.TradeType,
                json: e,
                orders_id: ordersId,
                ordersourcecate: this.Orders_SourceCate,
                isactivity
            };
            const result = await this.$newsApi.order.cartProductBatchAdd(dataObj);
            return result;
        },
        // 购物车商品数量
        async cartProductCountAmount() {
            let ordersId = this.changeOrderType == 0 ? this.orders_id : '-1';
            var result = await this.$newsApi.order.cartProductCountAmount({
                orders_buyerid: this.customerInfor.Member_ID,
                tradetype: this.TradeType,
                orders_id: ordersId,
                orders_type: this.Orders_Type
            });
            if (result.data.Resultcode == 0) {
                this.shoppingCarts = result.data.data;
            }
        },
        // 购物车商品是否在销售中
        async cartProductIsInsaleCount() {
            let ordersId = this.changeOrderType == 0 ? this.orders_id : '-1';
            var result = await this.$newsApi.order.cartProductIsInsaleCount({
                Orders_buyerID: this.customerInfor.Member_ID,
                TradeType: this.TradeType,
                orders_id: ordersId,
                Orders_type: this.Orders_Type
            });
            return result;
        },

        // 获取购物车列表
        async searchShoppingCart(e) {
            let ordersId = this.changeOrderType == 0 ? this.orders_id : '-1';
            let loadingInstance = this.$loading(); // 显示 loading
            var result = await this.$newsApi.order.OrdersGoodsList({
                orders_id: ordersId,
                orders_buyerid: this.customerInfor.Member_ID,
                orders_type: this.Orders_Type,
                tradetype: this.TradeType,
                spcapply_id: '',
                sessionid: '',
                good_id: e ? e.Goods_ID : ''
            });
            this.$closeLoading(loadingInstance); // 关闭 loading

            if (result.data.Resultcode == 0) {
                if (this.next < 4) {
                    this.next++;
                }
                // 添加默认选中属性
                if (result.data.data) {
                    result.data.data.map((item) => {
                        item.checked = false;
                        //item.Goods_Product_Name = item.Goods_Product_Name;
                        item.Goods_IsInsale = item.Goods_IsInsale == 1 ? '是' : '否';
                    });
                    this.Twlist = result.data.data;
                } else {
                    this.Twlist = [];
                }
                this.countPrice();
            } else {
                this.Twlist = [];
            }
            if (result.data.Resultinfo) {
                this.$message.warning(result.data.Resultinfo);
                return;
            }
        },
        countPrice() {
            var array = this.Twlist;
            var price = 0;
            var commitArray = [];
            var needCreatedNum = 0;
            for (let i = 0; i < array.length; i++) {
                price += array[i].Goods_Amount * array[i].Goods_Product_Price;
                commitArray.push(array[i]);
                if (array[i].IsOffer == '否') {
                    needCreatedNum++;
                }
            }
            needCreatedNum == array.length ? (this.createdShow = true) : (this.createdShow = false);
            this.allCartPrice = price.toFixed(2);
        },
        // 列表删除编辑按钮
        allDelete() {
            this.$confirm('您确定一键清空购物车吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '否',
                type: 'warning'
            })
                .then(async () => {
                    const loadingInstance = this.$loading(); // 显示 loading
                    this.nowCartId = this.Twlist.map((item) => item.Goods_ID);
                    var result = await this.deleteShop();
                    this.$closeLoading(loadingInstance); // 关闭 loading
                    if (result.resultcode == 0) {
                        this.$message.success(result.resultinfo);
                    }
                    setTimeout(() => {
                        this.cartProductCountAmount();
                        this.searchShoppingCart();
                        this.allPrice = 0;
                    }, 1000);
                })
                .catch(() => { })
                .finally(() => { });
        },
        listDelete(e) {
            this.$confirm('您确定要删除当前商品吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '否',
                type: 'warning'
            })
                .then(async () => {
                    this.nowCartId = e;
                    var result = await this.deleteShop();
                    if (result.resultcode == 0) {
                        this.$message.success(result.resultinfo);
                    }
                    setTimeout(() => {
                        this.searchShoppingCart();
                        this.allPrice = 0;
                    }, 1000);
                })
                .catch(() => { })
                .finally(() => { });
        },
        // 删除购物车商品
        async deleteShop() {
            let ordersId = this.changeOrderType == 0 ? this.orders_id : '-1';
            var coods = this.nowCartId.join();
            var result = await this.$newsApi.order.officeCartGoodstmpDel({
                orders_id: ordersId,
                orders_buyerid: this.customerInfor.Member_ID,
                orders_type: this.Orders_Type,
                tradetype: this.TradeType,
                SessionID: '',
                good_id: coods
            });
            return result;
        },
        // 跳转创建合同页面
        async goSubmit(e) {
            if (!this.Twlist || this.Twlist.length === 0) {
                this.$message.warning('购物车没有商品，请先添加商品');
                return;
            }
            let result = await this.cartProductIsInsaleCount();
            if (result.data.Resultcode == 1) {
                return;
            }
            this.isConfirmCart = 0;
            if (e == 0) {
                this.TradeType = 2;
                const hasOffer = this.Twlist.some((item) => item.IsOffer === '是');
                if (hasOffer) {
                    this.$confirm('含"仅报价用"商品，仅可选择纸质合同下单，是否确认？', '提示', {
                        confirmButtonText: '是',
                        cancelButtonText: '否',
                        type: 'warning'
                    })
                        .then(() => {
                            this.TradeType = 1;
                            this.isini = true;
                            this.next++;
                        })
                        .catch(() => {
                            return;
                        });
                } else {
                    this.isini = true;
                    this.next++;
                }
            } else if (e == 1) {
                this.TradeType = 1;
                this.isini = true;
                this.next++;
            }
        },
        // 完善订单页面回调
        async submitMountedMethods() {
            this.isini = true;
            if (this.Orders_SourceCate == 2) {
                this.SPCOrdersConfirm_Goods_List1();
            } else {
                this.SPCOrdersConfirm_Goods_List();
            }
            this.IsHonly = 0;
            if (this.Orders_Type == 1) {
                this.CheckCartIsHonly();
            }
            await this.CheckSPCOrdersProjectType();
            this.$refs.SubmitSpcOrder.GetBranchOfficeByID();
            if (this.orders_id != -1) {
                // 合同修改
                this.$refs.SubmitSpcOrder.getSPCOrdersDetails({ orders_id: this.orders_id });
            }
            if (this.apply_id) {
                // 一键转订单
                this.$refs.SubmitSpcOrder.getSPCApplyByID({ apply_id: this.apply_id });
            }
            if (this.PipelineCustomer.ID) {
                this.$refs.SubmitSpcOrder.currentDataPipelineList(this.PipelineCustomer);
            }
        },
        async CheckCartIsHonly() {
            let ordersId = this.changeOrderType == 0 ? this.orders_id : '-1';
            let res = await this.$newsApi.order.CheckCartIsHonly({
                orders_id: ordersId,
                Orders_buyerID: this.customerInfor.Member_ID,
                Orders_type: this.Orders_Type,
                TradeType: 2
            });
            if (res.data.data == 1) {
                this.IsHonly = 1;
            }
        },
        // 检查项目类型
        async CheckSPCOrdersProjectType() {
            if (Number(this.Orders_SourceCate) === 1) {
                this.IsShowProjectType = false;
                return;
            }
            const buyerId = this.customerInfor && this.customerInfor.Member_ID ? this.customerInfor.Member_ID : 0;
            if (!buyerId) {
                return;
            }
            let ordersId = this.changeOrderType == 0 ? this.orders_id : '-1';
            try {
                const res = await this.$newsApi.order.Check_SPCOrdersProjectType({
                    orders_id: ordersId,
                    Orders_buyerID: buyerId,
                    Orders_type: this.Orders_Type,
                    TradeType: 2
                });
                const resultData = res && res.data ? res.data.data : null;
                this.IsShowProjectType = Array.isArray(resultData) ? resultData.length > 0 : !!(resultData && resultData.length > 0);
            } catch (error) {
                this.IsShowProjectType = false;
            }
        },
        // 打包订单-打包订单确认-商品清单-
        async SPCOrdersConfirm_Goods_List(e) {
            let json = '';
            if (e == '折扣') {
                json = JSON.stringify(this.discountObj);
            } else {
                json = JSON.stringify(this.createdObj());
            }
            let ordersId = this.changeOrderType == 0 ? this.orders_id : '-1';
             // 复制合同时，优先使用orders_id作为Source_SPCOrdersID
            let sourceSpcOrdersId = this.changeOrderType == 0 
                ? this.resultInfo.Orders_ID 
                : (this.resultInfo.SPCOrders_ID || this.orders_id);
            let result = await this.$newsApi.order.SPCOrdersConfirm_Goods_List({
                json: json,
                isini: this.isini,
                ispreview: this.ispreview,
                Orders_ID: ordersId,
                Orders_type: 0,
                Orders_BuyerID: this.customerInfor.Member_ID,
                ifBack: true,
                OrderSourceCate: this.Orders_SourceCate, //合同来源类型
                CustomerID: this.customerInfor.Customer_ID, //客户ID
                CustomerSubID: this.customerInfor.Customer_Sub_ID, //二级客户ID
                Apply_ID: this.resultInfo.Apply_ID || 0,
                Source_SPCOrdersID: sourceSpcOrdersId
            });

            this.isini = false;
            if (result.data.data) {
                if (result.data.data.NormalList) {
                    result.data.data.NormalList.map((item) => {
                        item.Goods.map((items) => (items.checked = true)), (item.inputValue = '');
                    });
                    if (this.isConfirmCart == 1) {
                        this.confirmCartList = result.data.data.NormalList;
                    } else {
                        this.cartList = result.data.data.NormalList;
                    }
                }
                if (result.data.data.ActivityList) {
                    result.data.data.ActivityList.map((item) => {
                        item.Goods.map((items) => (items.checked = true)), (item.inputValue = '');
                    });
                    if (this.isConfirmCart == 1) {
                        this.confirmActivityCartList = result.data.data.ActivityList;
                    } else {
                        this.activityCartList = result.data.data.ActivityList;
                    }
                }
                this.cartgoods = result.data.Resultinfo;
            }
            this.Total_Price = result.data.Total_Price.toFixed(2) || 0;
        },
        // 打包订单-打包订单确认-商品清单-独立打包订单
        async SPCOrdersConfirm_Goods_List1(e) {
            let json = '';
            if (e == '折扣') {
                json = JSON.stringify(this.discountObj);
            } else {
                json = JSON.stringify(this.createdObj());
            }
            let ordersId = this.changeOrderType == 0 ? this.orders_id : '-1';
            let sourceSpcOrdersId = this.changeOrderType == 0 
                ? this.resultInfo.Orders_ID 
                : (this.resultInfo.SPCOrders_ID || this.orders_id);
            var result = await this.$newsApi.order.SPCOrdersConfirm_Goods_List1({
                json: json,
                isini: this.isini,
                ispreview: this.ispreview,
                Orders_ID: ordersId,
                orders_type: this.Orders_Type,
                orders_buyerid: this.customerInfor.Member_ID,
                ifBack: true,
                ordersourcecate: this.Orders_SourceCate, //合同来源类型
                customerid: this.customerInfor.Customer_ID, //客户ID
                customersubid: this.customerInfor.Customer_Sub_ID, //二级客户ID
                apply_id: this.resultInfo.Apply_ID || 0,
                source_spcordersid: sourceSpcOrdersId
            });
            this.isini = false;
            if (result.data.data) {
                if (result.data.data.NormalList) {
                    result.data.data.NormalList.map((item) => {
                        item.List.map((items) => {
                            items.Goods.map((itemChildren) => {
                                itemChildren.checked = true;
                            }),
                                (items.inputValue = '');
                        }),
                            (item.inputValue = '');
                    });
                    if (this.isConfirmCart == 1) {
                        this.confirmCartList = result.data.data.NormalList;
                    } else {
                        this.cartList = result.data.data.NormalList;
                    }
                }
                if (result.data.data.ActivityList) {
                    result.data.data.ActivityList.map((item) => {
                        item.List.map((items) => {
                            items.Goods.map((itemChildren) => {
                                itemChildren.checked = true;
                            }),
                                (items.inputValue = '');
                        }),
                            (item.inputValue = '');
                    });
                    if (this.isConfirmCart == 1) {
                        this.confirmActivityCartList = result.data.data.ActivityList;
                    } else {
                        this.activityCartList = result.data.data.ActivityList;
                    }
                }
                this.cartgoods = result.data.Resultinfo;
                this.Total_Price = result.data.Total_Price.toFixed(2) || 0;
                let cartListArr = this.cartList.concat(this.activityCartList);
                for (let item of cartListArr) {
                    this.allMoney += item.Orders_Price;
                    if (item.Remark) {
                        this.$message.warning(item.Remark);
                    }
                    for (let towMenus of item.List) {
                        if (towMenus.Remark) {
                            this.$message.warning(towMenus.Remark);
                        }
                        for (let threeMenus of towMenus.Goods) {
                            if (threeMenus.Tip) {
                                this.$message.warning(threeMenus.Tip);
                            }
                        }
                    }
                }
            }
        },
        // 计算折扣
        computerMethods(obj) {
            var needObj = this.createdObj();
            for (var key in obj) {
                needObj[key] = obj[key];
            }
            this.discountObj = needObj;
            this.SPCOrdersConfirm_Goods_List('折扣');
        },
        // 计算折扣
        computerMethods1(obj) {
            var needObj = this.createdObj();
            for (var key in obj) {
                needObj[key] = obj[key];
            }
            this.discountObj = needObj;
            this.SPCOrdersConfirm_Goods_List1('折扣');
        },
        // 序列化对象
        createdObj(e) {
            var obj = {};
            let ordersId = this.changeOrderType == 0 ? this.orders_id : '-1';
            obj.orders_id = ordersId;
            obj.Orders_type = this.Orders_Type;
            obj.Orders_SourceCate = this.Orders_SourceCate;
            obj.apply_id = this.apply_id || '';
            obj.Apply_SN = this.resultInfo.Apply_SN;
            if (this.orders_id && this.orders_id != -1) {
                obj.apply_id = this.resultInfo.Apply_ID;
            }

            obj.orders_target = e || ''; //默认空为保存，1为下一步
            obj.isconfirm = ''; //默认空为保存，1为提交
            obj.orders_copy = this.orders_copy;
            if (this.orders_copy == 1) {
                obj.apply_id = -1;
                // obj.SPCOrders_id = this.apply_id;
            }
            obj.paperorders = this.TradeType; //纸质合同为1，普通合同0

            obj.Orders_Attachment = ''; //合同附件
            obj.Orders_ApprovalAttachment = this.uploadmentList.join('|');

            obj.cartgoods = this.cartgoods || ''; //商品清单列表获取的数据

            obj.Orders_PayType_ID = this.submitpaymentObj.id; //付款方式ID
            obj.paytype_name = this.submitpaymentObj.value || this.submitpaymentObj.name; //付款方式名称
            obj.prepay_percent = this.submitpaymentObj.needPayCode.prepay_percent; //预付比例	浮点型
            obj.nextpay_days = this.submitpaymentObj.needPayCode.nextpay_days; //付款期
            obj.second_percent = this.submitpaymentObj.needPayCode.second_percent; //二期预付比例
            obj.second_days = this.submitpaymentObj.needPayCode.secondpay_days; //调试付款期
            obj.third_percent = this.submitpaymentObj.needPayCode.third_percent; //尾款比例
            obj.retention_percent = this.submitpaymentObj.needPayCode.retention_percent; //剩余比例
            obj.Expired_PayDate = this.submitpaymentObj.needPayCode.Expired_PayDate; //最迟结算日期

            obj.Orders_BuyerID = this.customerInfor.Member_ID; //会员ID
            obj.member_id = this.customerInfor.Member_ID; //会员ID
            obj.customer_id = this.customerInfor.Customer_ID; //客户ID
            obj.Customer_Sub_ID = this.customerInfor.Customer_Sub_ID || ''; //二级客户ID
            obj.Customer_Name = this.customerInfor.Customer_Name; //客户名称
            obj.Customer_Mobile = this.customerInfor.Customer_Mobile || ''; //客户手机
            let spcOrderinfo = this.$refs.SubmitSpcOrder.getFormParams();
            obj.Orders_Contract_Name = spcOrderinfo.Orders_Contract_Name; //联系人姓名
            obj.Orders_Contract_Mobile = spcOrderinfo.Orders_Contract_Mobile; //联系人手机
            obj.Orders_Contract_Email = spcOrderinfo.Orders_Contract_Email; //联系人邮箱

            if (this.customerInfor.Customer_Type == 1) {
                obj.Customer_Name = this.customerInfor.Person_Name;
                obj.Customer_Mobile = this.customerInfor.Person_Mobile;
                obj.Orders_Contract_Name = this.customerInfor.Person_Name; //联系人姓名
                obj.Orders_Contract_Mobile = this.customerInfor.Person_Mobile; //联系人手机
            }
            obj.Orders_PaperContractSN = spcOrderinfo.Orders_PaperContractSN; //纸质合同编号
            obj.Customer_Project_Country = '1'; //项目国家
            obj.Customer_Project_State = spcOrderinfo.Customer_Project_State; //项目省份
            obj.Customer_Project_City = spcOrderinfo.Customer_Project_City; //项目市
            obj.Customer_Project_County = spcOrderinfo.Customer_Project_County; //项目区
            obj.Customer_Project_Name = spcOrderinfo.Customer_Project_NameThree + spcOrderinfo.Customer_Project_Name + spcOrderinfo.Customer_Project_NameTwo; //项目名称
            obj.customer_project_name = spcOrderinfo.Customer_Project_Name; //主体项目名称
            obj.Orders_ProjectType_ID = spcOrderinfo.Orders_ProjectType_ID_Three ? spcOrderinfo.Orders_ProjectType_ID_Three : spcOrderinfo.Orders_ProjectType_ID_Two ? spcOrderinfo.Orders_ProjectType_ID_Two : spcOrderinfo.Orders_ProjectType_ID; //项目类型ID

            if (this.Orders_SourceCate != 1 && this.Orders_Type == 0) {
                obj.Orders_OfficeManID = spcOrderinfo.Orders_OfficeManID; //业务员id
                obj.Orders_OfficeManName = spcOrderinfo.Orders_OfficeManName; //业务员名字
                obj.CabinetSupplier = spcOrderinfo.CabinetSupplier; // 配电柜
                obj.CabinetSupplierName = spcOrderinfo.CabinetSupplierName; // 配电柜名字
            }


            obj.Orders_MsgNotify = spcOrderinfo.informValur.join().indexOf('1') > -1 ? 1 : 0; //短信通知客户
            obj.Orders_MsgNotify1 = spcOrderinfo.informValur.join().indexOf('2') > -1 ? 1 : 0; //短信通知业务员
            obj.Orders_Address_ID = ''; //收货地址编号

            obj.Orders_Address_Country = '1'; //收货地址国家
            obj.Orders_Address_State = spcOrderinfo.Orders_Address_State; /// 收货地省份
            obj.Orders_Address_City = spcOrderinfo.Orders_Address_City; //收货地址市
            obj.Orders_Address_County = spcOrderinfo.Orders_Address_County; //收货地址区
            obj.Orders_Address_StreetAddress = spcOrderinfo.Orders_Address_StreetAddress; //配送收货地址
            obj.Orders_Address_Zip = spcOrderinfo.Orders_Address_Zip; //收货地址邮编
            obj.Orders_Address_Mobile = spcOrderinfo.Orders_Address_Mobile; /// 收货人手机
            obj.Orders_Address_Name = spcOrderinfo.Orders_Address_Name; //收货人
            obj.Orders_Address_Phone_Number = spcOrderinfo.Orders_Address_Phone_Number; /// 收货人固话
            obj.AddressType = spcOrderinfo.Orders_Address_StreetAddress_type; /// 收货地类型

            obj.order_note = spcOrderinfo.order_note; //订单备注
            obj.Invoice_ID = ''; //发票号
            obj.admin_note = ''; //管理员备注

            obj.Orders_Delivery_ID = spcOrderinfo.Orders_Delivery_ID; /// 配送方式ID
            obj.delivery_name = spcOrderinfo.delivery_name; /// 其他配送方式，DeliveryID=2时必填

            obj.Orders_Payway_ID = spcOrderinfo.payWayValue; //支付方式ID
            obj.Orders_Payway_Name = spcOrderinfo.payWayName;
            obj.Orders_Payway_Type = 0;
            // obj.Receipt_ID = this.jsonShowData.Receipt_ID		//付款凭证
            // obj.Receipt_Amount = this.jsonShowData.Receipt_Amount//

            obj.Orders_DeliveryTime = spcOrderinfo.Orders_DeliveryTime; /// 交货时间
            obj.Orders_PlanDeliveryDate = spcOrderinfo.Orders_PlanDeliveryDate; /// 期望交货时间
            obj.Orders_IsAllFreight = spcOrderinfo.Orders_IsAllFreightValue; /// 整单发货	整型，必填，0：分批发货，1：整单发货
            obj.Orders_IsAllReach = spcOrderinfo.Orders_IsAllReach;
            obj.Orders_FreightType = spcOrderinfo.Orders_FreightType; /// 发货方式	整型，默认0;0：即时发货；1:审核后发货

            obj.Orders_IsPayAuditDelivery = 0; //付款审核后自动发货
            obj.Orders_CustomerPartA = ''; //甲方名称
            obj.Orders_OtherAgreement = spcOrderinfo.Orders_OtherAgreement; //
            if (spcOrderinfo.Orders_OtherAgreementIDArr.length) {
                obj.Orders_OtherAgreementIDArr = spcOrderinfo.Orders_OtherAgreementIDArr.join(';');
            } else {
                obj.Orders_OtherAgreementIDArr = '';
            }
            obj.Orders_OtherAgreementText = spcOrderinfo.Orders_OtherAgreementText; //合同其他约定
            // obj.Orders_IsSpecialPriceAudit = this.Orders_IsSpecialPriceAudit	//特价审纶
            obj.Orders_ProjectType = spcOrderinfo.SPCOrdersProjectTypeId; //1新建项目  2已建项目(升级改造)
            obj.Orders_ProjectNote = ''; //工基建项目说明
            obj.SessionID = '';
            if (this.PipelineCustomer) {
                obj.Pipeline_ID = this.PipelineCustomer.ID || '';
            }
            if (this.isReturnGoods == 1) {
                obj.SPCApply_AdderID = 1;
                obj.returngoods = 1;
            }

            return obj;
        },
        // 合同检查
        // this.OrdersCreate({name:'保存',type:0})
        // this.OrdersCreate({name:'下一步',type:1},1,result.data.SPCApply_ID)
        async OrdersCreate(e, i, n) {
            var json = this.createdObj(e.type);
            if (i == 1) {
                json.relation = i ? 1 : 0;
                json.apply_id = n;
            }

            if (this.changeOrderType == 2) {
                json.apply_id = this.resultInfo.Apply_ID;
            }

            if (i == 2) {
                json.freightlimitdiscount = 2;
                if (this.JsonSPCApply_ID) {
                    json.relation = 1;
                    json.apply_id = this.JsonSPCApply_ID;
                }
            }
            // 提取购物车折扣价参数
            var list = this.cartList.concat(this.activityCartList);
            var obj = {};
            if (this.Orders_SourceCate == 0) {
                for (let i = 0; i < list.length; i++) {
                    for (let j = 0; j < list[i].Goods.length; j++) {
                        obj['discountprice_' + list[i].Goods[j].Goods_ID] = list[i].Goods[j].Goods_Product_AdjustDiscountPrice;
                    }
                }
            } else {
                for (let i = 0; i < list.length; i++) {
                    for (let k = 0; k < list[i].List.length; k++) {
                        for (let j = 0; j < list[i].List[k].Goods.length; j++) {
                            obj['discountprice_' + list[i].List[k].Goods[j].Goods_ID] = list[i].List[k].Goods[j].Goods_Product_AdjustDiscountPrice;
                        }
                    }
                }
            }

            // 合同其它约定处理
            let otherAgreementData = json.Orders_OtherAgreementIDArr;
            if (json.Orders_OtherAgreementText) {
                if (otherAgreementData) {
                    otherAgreementData += ';其他：' + json.Orders_OtherAgreementText;
                } else {
                    otherAgreementData += '其他：' + json.Orders_OtherAgreementText;
                }
            }
            json.Orders_OtherAgreement = otherAgreementData;
            // 将obj合并到 jsonObj里面
            for (var key in obj) {
                json[key] = obj[key];
            }
            if (this.isReturnGoods == 1) {
                json.returngoods = 1;
            }
            json = JSON.stringify(json);
            let loadingInstance = this.$loading(); // 显示 loading
            var resultCrea = await this.$newsApi.order.SPCOrders_Create({
                json: json,
                SourceType: 'PC'
            });
            this.$closeLoading(loadingInstance); // 关闭 loading
            let result = resultCrea.data;

            if (result.Resultcode == 0 && result.total == 999) {
                this.$confirm(result.Resultinfo, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '否',
                    type: 'warning'
                }).then(async () => {
                    this.JsonSPCApply_ID = result.data.SPCApply_ID;
                    this.apply_id = result.data.SPCApply_ID;
                    this.$newsApi.order.GetSPCApplyByID({ ID: this.apply_id }).then(async (result) => {
                        this.customerInfor.Member_ID = result.data.data.SPCApply_BuyerID; //会员ID
                        this.customerInfor.Customer_ID = result.data.data.SPCApply_CustomerID; //客户ID
                        this.customerInfor.Customer_Sub_ID = result.data.data.SPCApply_CustomerSubID; //二级客户ID
                        this.customerInfor.Customer_Name = result.data.data.SPCApply_CustomerName; //客户名称
                        this.customerInfor.Customer_Mobile = result.data.data.SPCApply_CustomerMobile; //客户手机
                        this.resultInfo.Apply_SN = result.data.data.SPCApply_SN;
                        await this.$refs.SubmitSpcOrder.getSPCApplyByID_Project({ apply_id: this.apply_id });
                        this.OrdersCreate({ name: '下一步', type: 1 }, 1, result.data.SPCApply_ID);
                    });
                })
                    .catch(() => {
                        this.JsonSPCApply_ID = '';
                    });
                return;
            }
            if (result.Resultcode == 0 && result.total == 998) {
                this.$confirm(result.Resultinfo, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '否',
                    type: 'warning'
                }).then(() => {
                    if (result.Resultinfo.includes('整单发货')) {
                        this.Orders_IsAllFreight = 1;
                    }
                    this.OrdersCreate({ name: '下一步', type: 1 }, 2, 2);
                })
                    .catch(() => {
                        this.JsonSPCApply_ID = '';
                    });
                return;
            }

            if (result.Resultcode == 0 && e.name == '保存') {
                this.$message.success('保存合同成功！');
                let orders_id = JSON.parse(json).orders_id || -1;
                sessionStorage.setItem('ContractPreservation', JSON.stringify({ orders_id: orders_id }));
                this.resetDataMy();
                setTimeout(() => {
                    this.$router.push({ path: '/orderManagement/contractmanagementAll', query: { t: Date.now() } });
                }, 1000);
            } else if (e.name == '下一步' && result.Resultcode == 0) {
                json = JSON.parse(json);
                // if(i==1){
                //     json.apply_id = n
                // } else {
                //     json.apply_id = this.$store.state.ChangeSPCApplyData.Apply_ID
                // }
                let msgInfo = result.Resultinfo.includes('[BPM]') ? `本单需BPM审批，原因：${result.Resultinfo.split('[BPM]')[1]}` : result.Resultinfo;
                if (msgInfo && i != 2) {
                    this.$confirm(msgInfo, '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '否',
                        type: 'warning'
                    }).then(() => {
                        this.comfirmSpcOrder(json, result.data);
                    });
                } else {
                    this.comfirmSpcOrder(json, result.data);
                }
                if (this.Orders_SourceCate == 2) {
                    this.resetSpcId();
                }
            } else if (result.Resultcode == 1) {

                if (result.Resultinfo.indexOf('noprice') > 0) {
                    this.$confirm(result.Resultinfo.replace('[noprice]', ''), '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '否',
                        type: 'warning'
                    }).then(() => {
                        json = JSON.parse(json);
                        this.comfirmSpcOrder(json, result.data);
                    })
                        .catch((e) => {
                            this.$message.$alert(e);
                        });
                    return;
                } else {
                    this.$alert(result.Resultinfo, '提示', {
                        confirmButtonText: '确定',
                        type: 'warning'
                    }).then(() => {
                        if (this.Orders_SourceCate == 2 && this.changeOrderType != 1) {
                            this.resetSpcId();
                        }
                        return;
                    });
                }


            }
        },
        // 合同确认页面方法
        async comfirmSpcOrder(orderInfo, result) {
            this.ispreview = true;
            this.isConfirmCart = 1;
            if (this.Orders_SourceCate == 2) {
                this.$refs.SubmitSpcOrder.userComputer1();
            } else {
                this.$refs.SubmitSpcOrder.userComputer();
            }
            if (result != null) {
                orderInfo.Orders_IsPayAuditDelivery_Type = result.Orders_IsPayAuditDelivery_Type;
            }
            else {
                // orderInfo.Orders_IsPayAuditDelivery_Type = "";
                //非零预付、审核后发货、整单发货
                if (orderInfo.Orders_PrePay_Percent > 0 && orderInfo.Orders_FreightType == 1 && orderInfo.Orders_IsAllFreight == 1 && this.returngoods != 1) {
                    //服务订单时默认
                    if (orderInfo.orders_type == 1) {
                        orderInfo.Orders_IsPayAuditDelivery_Type = "hidden";
                    }
                    else {
                        orderInfo.Orders_IsPayAuditDelivery_Type = "checkbox";
                    }
                }

            }
            if (this.Orders_IsAllFreight == 1) {
                orderInfo.Orders_IsAllFreight = 1;
            }
            orderInfo.ERP_SN = this.ERP_SN;
            
            // 确保在获取名称信息前，等待 SubmitSpcOrder 组件完全加载
            await this.$nextTick();
            let nameInfo = this.$refs.SubmitSpcOrder.getNameMethods();
            orderInfo = { ...orderInfo, ...nameInfo };
            
            this.JsonSPCApply_ID = '';
            this.next++;
            // 这里需要等待comfirmSpcOrderMethos组件加载完成
            this.$nextTick(() => {
                this.$refs.ConfirmSpcOrder.comfirmSpcOrderMethos(orderInfo);
            });
        },
        // 确认合同并提交
        async confirmOrdersCreate() {
            let json = this.$refs.ConfirmSpcOrder.getSpcOrderConfirmParams();
            // 提取购物车折扣价参数
            var list = this.confirmCartList.concat(this.confirmActivityCartList);
            // var obj = {};
            if (this.Orders_SourceCate == 0) {
                for (let i = 0; i < list.length; i++) {
                    for (let j = 0; j < list[i].Goods.length; j++) {
                        json['discountprice_' + list[i].Goods[j].Goods_ID] = list[i].Goods[j].Goods_Product_DiscountPrice;
                        json['FreightAmount_' + list[i].Goods[j].Goods_ID] = list[i].Goods[j].Goods_DeliveryAmount; //批量发货数量
                    }
                }
            } else {
                for (let i = 0; i < list.length; i++) {
                    for (let k = 0; k < list[i].List.length; k++) {
                        for (let j = 0; j < list[i].List[k].Goods.length; j++) {
                            json['discountprice_' + list[i].List[k].Goods[j].Goods_ID] = list[i].List[k].Goods[j].Goods_Product_DiscountPrice;
                            json['FreightAmount_' + list[i].List[k].Goods[j].Goods_ID] = list[i].List[k].Goods[j].Goods_DeliveryAmount; //批量发货数量
                        }
                    }
                }
            }
            json = JSON.stringify(json);
            const loadingInstance = this.$loading(); // 显示 loading
            var result = await this.$newsApi.order.SPCOrders_Create({
                json: json,
                SourceType: 'PC'
            });
            this.$closeLoading(loadingInstance); // 关闭 loading
            result = result.data;
            if (result.Resultcode == 0) {
                this.$message.success('合同提交成功！');
                // 跳转到订单页
                this.resetDataMy();
                setTimeout(() => {
                    if (result.Resultinfo) {
                        this.$router.push({ path: '/quotationManagement/index', query: { t: Date.now() } }); // 替换当前路由
                    } else {
                        this.$router.push({ path: '/orderManagement/contractmanagementAll', query: { t: Date.now() } }); // 替换当前路由
                    }
                }, 1000);
            } else if (result.Resultinfo) {
                this.$alert(result.Resultinfo, '提示', {
                    confirmButtonText: '确定',
                    type: 'warning'
                }).then(() => {
                    return;
                });
            }
        },
        // 柜台加入购物车
        async Cart_ControlCabinetPackage_Add(e) {
            let ordersId = this.changeOrderType == 0 ? this.orders_id : '-1';
            let dataObj = {
                ...e,
                Orders_Type: this.Orders_Type, //订单类型
                customerid: this.customerInfor.Customer_ID || 0, //客户ID
                customersubid: this.customerInfor.Customer_Sub_ID || 0, //二级客户ID
                Orders_buyerID: this.customerInfor.Member_ID,
                TradeType: this.TradeType,
                Orders_ID: ordersId,
                Orders_SourceCate: this.Orders_SourceCate
            };
            let json = JSON.stringify(dataObj);
            let loadingInstance = this.$loading(); // 显示 loading
            let result = await this.$newsApi.order.Cart_ControlCabinetPackage_Add({ json: json });
            this.$closeLoading(loadingInstance); // 关闭 loading
            if (result.data.Resultcode == 0) {
                this.$message.success(result.data.Resultinfo);
                this.cartProductCountAmount();
            }
        },
        async Cart_WallHanging_Add(e) {
            let ordersId = this.changeOrderType == 0 ? this.orders_id : '-1';
            let dataObj = {
                ...e,
                Orders_Type: this.Orders_Type, //订单类型
                customerid: this.customerInfor.Customer_ID || 0, //客户ID
                customersubid: this.customerInfor.Customer_Sub_ID || 0, //二级客户ID
                Orders_buyerID: this.customerInfor.Member_ID,
                TradeType: this.TradeType,
                Orders_ID: ordersId,
                Orders_SourceCate: this.Orders_SourceCate
            };
            let json = JSON.stringify(dataObj);
            let loadingInstance = this.$loading(); // 显示 loading
            let result = await this.$newsApi.order.Cart_WallHanging_Add({ json: json });
            this.$closeLoading(loadingInstance); // 关闭 loading
            if (result.data.Resultcode == 0) {
                this.$message.success(result.data.Resultinfo || '添加成功');
                this.cartProductCountAmount();
            }
        },
        async officeCartGoodstmpEdit(e) {
            this.cartEditing = true;
            let ordersId = this.changeOrderType == 0 ? this.orders_id : '-1';
            let obj = {
                Orders_id: ordersId,
                Orders_buyerID: this.customerInfor.Member_ID,
                Orders_Type: this.Orders_Type,
                TradeType: this.TradeType,
                SessionID: '',
                Customer_ID: this.customerInfor.Customer_ID, //客户ID
                Customer_SubID: this.customerInfor.Customer_Sub_ID || 0, //二级客户ID
                Good_id: e.Goods_ID,
                Buyamount: e.Goods_Amount
            };
            let result = await this.$newsApi.order.Office_Cart_Goodstmp_Edit(obj);
            if (result.data.resultcode == 0) {
                await this.searchShoppingCart(e);
            }
            this.cartEditing = false;
        },
        // 批量移除
        async deleterChoose() {
            const loadingInstance = this.$loading(); // 显示 loading
            if (this.nowCartList) {

            }
            else {
                this.$message.info("请勾选要批量删除的商品!");
                this.$closeLoading(loadingInstance); // 关闭 loading
                return;
            }
            this.nowCartId = this.nowCartList.map((item) => item.Goods_ID);

            if (this.nowCartId == "") {
                this.$message.info("请勾选要批量删除的商品!");
                this.$closeLoading(loadingInstance); // 关闭 loading
                return;
            }
            var result = await this.deleteShop();
            this.$closeLoading(loadingInstance); // 关闭 loading
            if (result.resultcode == 0) {
                this.$message.success(result.resultinfo);
            }
            setTimeout(() => {
                this.cartProductCountAmount();
                this.searchShoppingCart();
                this.allPrice = 0;
            }, 1000);
        },
        // 批量选择
        selectionChange(val) {
            this.nowCartList = val;
        },
        // 导入excel
        importExcel() {
            this.carExexlFilepath = '';
            this.importExcelShow = true;
        },
        // 导入excel
        async importCartGoods() {
            let json = JSON.stringify({ filepath: this.carExexlFilepath });
            let obj = {
                OrdersID: -1,
                Orders_buyerID: this.customerInfor.Member_ID,
                CustomerID: this.customerInfor.Customer_ID,
                CustomerSubID: this.customerInfor.SPCApply_CustomerSubID,
                OrderType: this.Orders_Type,
                TradeType: this.TradeType,
                json: json
            };
            this.$confirm('此操作将清空当前购物车中所有非促销的现场设备，仅保留配置好的主机设备及促销商品！', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '否',
                type: 'warning'
            }).then(async () => {
                const loadingInstance = this.$loading(); // 显示 loading
                let result = await this.$newsApi.order.ImportCartGoods(obj);
                if (result.data.Resultcode == 0) {
                    await this.searchShoppingCart();
                    this.$closeLoading(loadingInstance); // 关闭 loading
                    this.importExcelShow = false;
                    this.$message.success(result.data.Resultinfo);
                }
            });
        },
        // 购物车上传
        onSuccessExcel(e) {
            this.carExexlFilepath = e;
        },
        // 促销活动
        async cartActivityProductList(e) {
            if (e) {
                this.activityProductListOptions = {
                    PageSize: 40,
                    Page: 1,
                    total: 0
                };
            }
            let jsonData = { ...this.activityParams, promotionid: 0, IsActivity: 1 };
            jsonData = JSON.stringify(jsonData);
            let result = await this.$newsApi.order.getCartProductList({
                Orders_type: this.Orders_Type,
                Json: jsonData,
                Page: this.activityProductListOptions.Page,
                PageSize: this.activityProductListOptions.PageSize
            });
            if (result.data.data) {
                // 添加默认数量属性
                result.data.data.map((item) => {
                    (item.userDefinedNum = 0), (item.checkBox = true);
                });
                // this.productList = result.data.slice(0,10);
                this.activityProductList = result.data.data;
                this.activityProductListOptions.total = result.data.total;
                this.$nextTick(() => {
                    // 或者选中所有行
                    this.activityProductList.forEach((row) => {
                        this.$refs.activityProductListTable.toggleRowSelection(row, true);
                    });
                });
            } else {
                this.activityProductList = [];
            }
        },
        // 优惠专区
        async promotionsearchList(e) {
            if (e) {
                this.PromotionProductListOptions = {
                    PageSize: 40,
                    Page: 1,
                    total: 0
                };
            }
            let jsonData = { ...this.PromotionParams, product_cate: 0, DiscounntCate: 0 };
            jsonData = JSON.stringify(jsonData);
            let result = await this.$newsApi.order.getCartProductList({
                Orders_type: this.Orders_Type,
                Json: jsonData,
                Page: this.PromotionProductListOptions.Page,
                PageSize: this.PromotionProductListOptions.PageSize
            });
            if (result.data.data) {
                // 添加默认数量属性
                result.data.data.map((item) => {
                    (item.userDefinedNum = 0), (item.checkBox = true);
                });
                // this.productList = result.data.slice(0,10);
                this.promotionProductList = result.data.data;
                this.PromotionProductListOptions.total = result.data.total;
                this.$nextTick(() => {
                    // 或者选中所有行
                    this.promotionProductList.forEach((row) => {
                        this.$refs.promotionProductListTable.toggleRowSelection(row, true);
                    });
                });
            } else {
                this.promotionProductList = [];
            }
        },
        // 滚动监听，实现瀑布流加载
        handleScroll(event) {
            const { target } = event;
            const { scrollTop, scrollHeight, clientHeight } = target;

            // 当滚动到底部附近时加载更多数据
            if (scrollHeight - scrollTop - clientHeight < 100 && !this.loadingMore && !this.noMoreData) {
                this.loadMoreData();
            }
        },
        // 加载更多数据
        async loadMoreData() {
            if (this.loadingMore || this.noMoreData) return;

            // 记录当前滚动位置
            const container = this.$refs.tableContainer;
            if (container) {
                this.scrollPosition = container.scrollTop;
            }

            this.productListOptions.Page += 1;
            await this.cartProductList(false, true);

            // 加载完成后，调整滚动位置，使其离开底部
            this.$nextTick(() => {
                if (container) {
                    // 设置滚动位置，使新内容可见但不在底部
                    container.scrollTop = this.scrollPosition - 50;
                }
            });
        },
        activityListSizeChange(newSize) {
            this.activityProductListOptions.PageSize = newSize;
            this.cartActivityProductList();
        },
        activityListCurrentChange(newPage) {
            this.activityProductListOptions.Page = newPage;
            this.cartActivityProductList();
        },
        promoListSizeChange(newSize) {
            this.PromotionProductListOptions.PageSize = newSize;
            this.promotionsearchList();
        },
        promoListCurrentChange(newPage) {
            this.PromotionProductListOptions.Page = newPage;
            this.promotionsearchList();
        },
        continueShopping() {
            this.next--;
            this.activeName = '1';
            if (this.isReturnGoods == 1) {
                this.activeName = '2';
                this.cartProductList();
            } else {
                this.cartProductCommonList();
            }
        },
        // 设置为常用设备(删除，添加)
        addeQuipment(i, e) {
            let obj = {
                Product_ID: e.Product_ID,
                Action: i
            };
            this.$newsApi.order.ProductCommonAction(obj).then((res) => {
                if (res.data.resultcode == 0) {
                    this.$message.success(res.data.resultinfo);
                    if (i == 'del') {
                        this.cartProductCommonList();
                    } else {
                        this.cartProductList();
                    }
                } else {
                    this.$message.error(res.data.resultinfo);
                }
            });
        },
        // 获取表格行的类名，为新批次数据添加分隔线
        getRowClassName({ row, rowIndex }) {
            if (row.isNewBatch) {
                return 'new-batch-row';
            }
            return '';
        },
        // 完善订单页上一步
        goCarshop() {
            this.next--;
            // this.isini = true;
        },
        goconfirm() {
            this.isConfirmCart = 0;
            this.ispreview = false;
            this.next--;
            // this.isini = true;
        },
        // 支付方式上一步
        nextPayment() {
            // 重置关联的报价单
            if (this.spcId) {
                this.resetSpcId();
            }
            this.next--;
        },
        resetSpcId() {
            this.spcId = 0;
            // 保留复制合同场景下需要的source_spcordersid相关字段
            const { Orders_ID, SPCOrders_ID } = this.resultInfo;
            this.resultInfo = { Orders_ID, SPCOrders_ID };
            this.apply_id = '';
            this.changePayInfoData = {}; //付款方式
            this.SPCApply_PayTypeID = ''; //付款方式id
        },
        // 刷新页面
        resetData() {
            Object.assign(this.$data, this.$options.data());
            this.$router.replace({ path: this.$route.path });
            this.getCheckSPCOrderCreate();
            this.getHistoryCustomerList();
            this.$store.dispatch('fetchLocationData');
        },
        getFullImageUrl(path) {
            if (!path) return '';
            if (/^https?:\/\//.test(path)) return path;
            if (path.indexOf("detail_no_pic") > 0) return path;
            return this.$openFileUrl + path;
        },
        // 显示产品图片详情
        showImageDetail(product) {
            this.currentProductId = product.Product_ID
            this.showProductImgDialog = true
        },
        resetDataMy() {
            // let time = Date.now();
            // this.$router.push({ path: '/customOrder/index', query: { t: time } }); // 跳转之前先刷新自己
            this.$store.dispatch('delView', this.$route);

            // this.$store.dispatch('delCachedView', this.$route);
            // let obj = this.$route;
            // obj.fullPath = this.$route.path;
            // obj.query = {};
            // setTimeout(() => {
            //     this.$store.dispatch('addView', obj);
            // }, 1100);
        }
    }
};
</script>
<style scoped lang="scss">
.action {
    /deep/.custom-label {
        // background: #f5f7fa !important;
        max-width: 150px !important;
        min-width: 120px !important;
        line-height: 30px;
        display: inline-block;
        text-align: right !important;
        color: #000000;
        font-weight: bold;
    }

    /deep/ .el-descriptions-item__content {
        display: flex;
        align-items: center;
        color: #000000;
        font-size: 14px;
    }
}

/deep/.form-title {
    line-height: 40px;
    background-color: #eeeeee;
    padding-left: 15px;
}

/deep/.el-table {
    color: #000000;
}

/deep/.el-table thead {
    color: #000000;
}

/deep/ .el-descriptions__body {
    color: #000000;
}

/deep/.el-descriptions-item__label:not(.is-bordered-label) {
    color: #000000;
    font-weight: bold;
    font-size: 14px;
}

/deep/.el-form-item__label {
    color: #000000;
    font-weight: bold !important;
}

/deep/.el-form .el-form-item .el-form-item__label {
    font-weight: bold !important;
}

/deep/.info .info-item .label {
    font-weight: bold;
}

/deep/.el-radio {
    color: #000000;
}

/deep/ .el-step__title {
    font-size: 14px !important;
}

/deep/ .el-step__title.is-process {
    font-size: 14px !important;
}

/deep/ .el-tabs__nav-wrap::after {
    height: 1px !important;
}

.nav-title {
    padding: 40px 20px 20px 20px;
}

.steps {
    transform: scale(0.85);
}

.content-view {
    background: #fff;
    padding: 20px;
    margin-bottom: 50px;
    overflow-y: auto;
}

::v-deep .content-view .custom-label {
    text-align: right !important;
    width: 120px;
    color: #333;
    // background-color: #f5f7fa !important;
}

::v-deep .content-view .el-collapse-item__header {
    font-size: 15px;
    color: #222;
    font-weight: 500 !important;
}

.content-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 0px !important;
}

.customers-info {
    margin-top: 20px;
}

.his-customers-list {
    margin-top: 20px;
}

.his-customers {
    line-height: 30px;
}

.signature-tips {
    border: 1px dashed #90dd90;
    font-style: normal;
    font-size: 12px;
    color: #008000;
    line-height: 20px;
    display: inline-block;
    vertical-align: middle;
    margin-left: 10px;
    background-color: #95ffa0;
    padding: 0 4px;
    border-radius: 0 10px 0 10px;
}

.action-title {
    padding-bottom: 15px;
    border-bottom: 1px solid #e4e7ed;
    margin-bottom: 15px;
}

.labelClassNameBox {
    /deep/.labelClassName {
        width: 150px;
        text-align: right;
    }

    .rows {
        width: 350px;
    }
}

.content_Pipeline {
    display: flex;
    width: 500px;
    flex-wrap: wrap;
    margin-top: 10px;

    div {
        margin-right: 10px;
    }

    .content_title {
        font-weight: 700;
        letter-spacing: 2rpx;
        width: 600rpx;
    }
}

.content {
    height: calc(100vh - 104px);
    min-height: 400px;
    display: flex;
    flex-direction: column;
}

.content-view {
    flex: 1;
    display: flex;
    flex-direction: column;
}

.tabs-container {
    position: relative;
    flex: 1;
    display: flex;
    flex-direction: column;
}

.sticky-tabs {
    position: sticky;
    top: -20px;
    z-index: 10;
    background: #fff;
}

.sticky-form {
    padding: 16px;
    background: #fff;
    border-bottom: 1px solid #e4e7ed;
}

.scroll-content {
    flex: 1;
    overflow-y: auto;
    padding: 20px 0;
}

/deep/.storage_list {
    display: block;
}

/* 表格容器样式 */
.table-container {
    max-height: 600px;
    overflow-y: auto;
    position: relative;
}

/* 加载更多提示样式 */
.loading-more {
    text-align: center;
    padding: 20px;
    color: #666;
    font-size: 14px;
}

.loading-more i {
    margin-right: 8px;
    animation: rotating 2s linear infinite;
}

@keyframes rotating {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}

/* 新批次数据分隔线样式 */
/deep/ .new-batch-row {
    border-top: 3px solid #409eff !important;
}

/deep/ .new-batch-row td {
    border-top: 3px solid #409eff !important;
}

/* 没有更多数据提示样式 */
.no-more-data {
    text-align: center;
    padding: 20px;
    color: #999;
    font-size: 14px;
    border-top: 1px solid #eee;
}
</style>
